// // import React, { useEffect, useState } from "react";
// // import { Link, useNavigate } from "react-router-dom";
// // import { FaPlus } from "react-icons/fa";
// // import { Modal, Button, Form, Table, Pagination, Row, Col, Container, Carousel } from "react-bootstrap";
// // import { FaEdit } from "react-icons/fa";
// // import { RiDeleteBin3Fill } from "react-icons/ri";
// // import { HiOutlineChevronLeft, HiChevronRight } from "react-icons/hi2";
// // import { BsThreeDots, BsEye } from "react-icons/bs";
// // import { FaDownload } from "react-icons/fa";

// // const API_URL = process.env.REACT_APP_API_URL;
// // const IMG_URL = process.env.REACT_APP_Image_URL;

// // function BankAccountList() {
// //     const navigate = useNavigate();
// //     const [accounts, setAccounts] = useState([]);
// //     const [loading, setLoading] = useState(true);
// //     const [error, setError] = useState(null);
// //     const [currentPage, setCurrentPage] = useState(1);
// //     const [totalPages, setTotalPages] = useState(1);
// //     const [editModalData, setEditModalData] = useState({
// //         show: false,
// //         id: null,
// //         payee: "",
// //         bank_account_name: "",
// //         account_number: "",
// //         ifsc_code: "",
// //         type: "",
// //         images: [],
// //         existing_images: []
// //     });
// //     const [deleteModalData, setDeleteModalData] = useState({
// //         show: false,
// //         id: null,
// //         name: "",
// //     });
// //     const [imagesModalData, setImagesModalData] = useState({
// //         show: false,
// //         images: [],
// //         title: ""
// //     });
// //     const [newImages, setNewImages] = useState([]);
// //     const [imagePreviews, setImagePreviews] = useState([]);
// //     const [actionLoading, setActionLoading] = useState(false);
// //     const [showToast, setShowToast] = useState(false);
// //     const [toastMessage, setToastMessage] = useState("");
// //     const [toastVariant, setToastVariant] = useState("success");

// //     const getAuthToken = () => {
// //         return localStorage.getItem("token");
// //     };

// //     const showToastMessage = (message, variant) => {
// //         setToastMessage(message);
// //         setToastVariant(variant);
// //         setShowToast(true);
// //         setTimeout(() => setShowToast(false), 3000);
// //     };

// //     const fetchBankAccounts = async (page = 1) => {
// //         setLoading(true);
// //         const token = getAuthToken();
// //         if (!token) {
// //             setError("Authentication token not found. Please log in.");
// //             setLoading(false);
// //             return;
// //         }

// //         try {
// //             const response = await fetch(
// //                 `${API_URL}/expence-bank-account-list?page=${page}&limit=10`,
// //                 {
// //                     method: "GET",
// //                     headers: {
// //                         Authorization: `Bearer ${token}`,
// //                     },
// //                 }
// //             );

// //             if (!response.ok) {
// //                 if (response.status === 401) {
// //                     navigate('/login');
// //                 }
// //                 throw new Error("Failed to fetch bank accounts.");
// //             }

// //             const data = await response.json();
// //             if (data.status) {
// //                 // Add images array to each account if image field exists
// //                 const accountsWithImages = data.data.map(account => ({
// //                     ...account,
// //                     images: account.image ? account.image.split(',') : []
// //                 }));
// //                 setAccounts(accountsWithImages);
// //                 setTotalPages(data.totalPages || 1);
// //                 setCurrentPage(data.currentPage || page);
// //             } else {
// //                 setError(data.message || "No bank accounts found.");
// //                 setAccounts([]);
// //             }
// //         } catch (err) {
// //             console.error("Fetch error:", err);
// //             setError(err.message);
// //             setAccounts([]);
// //         } finally {
// //             setLoading(false);
// //         }
// //     };

// //     useEffect(() => {
// //         fetchBankAccounts(currentPage);
// //     }, [currentPage]);

// //     const handleEditClick = async (id) => {
// //         setActionLoading(true);
// //         const token = getAuthToken();
// //         if (!token) {
// //             showToastMessage("Authentication token not found.", "danger");
// //             setActionLoading(false);
// //             return;
// //         }
// //         try {
// //             const response = await fetch(`${API_URL}/expence-bank-account-edit`, {
// //                 method: "POST",
// //                 headers: {
// //                     "Content-Type": "application/json",
// //                     Authorization: `Bearer ${token}`,
// //                 },
// //                 body: JSON.stringify({ id: id }),
// //             });
// //             const result = await response.json();
// //             if (response.ok && result.status) {
// //                 setEditModalData({
// //                     show: true,
// //                     id: result.data.id,
// //                     payee: result.data.payee || "",
// //                     bank_account_name: result.data.bank_account_name || "",
// //                     account_number: result.data.account_number || "",
// //                     ifsc_code: result.data.ifsc_code || "",
// //                     type: result.data.type || "",
// //                     images: result.data.images || [],
// //                     existing_images: result.data.images || []
// //                 });
// //                 setNewImages([]);
// //                 setImagePreviews([]);
// //             } else {
// //                 throw new Error(result.message || "Failed to fetch account details.");
// //             }
// //         } catch (err) {
// //             console.error("Edit fetch error:", err);
// //             showToastMessage(err.message, "danger");
// //         } finally {
// //             setActionLoading(false);
// //         }
// //     };

// //     const handleDeleteClick = (account) => {
// //         setDeleteModalData({
// //             show: true,
// //             id: account.id,
// //             name: account.payee,
// //         });
// //     };

// //     const handleViewImagesClick = (account) => {
// //         setImagesModalData({
// //             show: true,
// //             images: account.images,
// //             title: `Images for ${account.payee}`
// //         });
// //     };

// //     const handleEditModalClose = () => {
// //         setEditModalData({
// //             show: false,
// //             id: null,
// //             payee: "",
// //             bank_account_name: "",
// //             account_number: "",
// //             ifsc_code: "",
// //             type: "",
// //             images: [],
// //             existing_images: []
// //         });
// //         setNewImages([]);
// //         setImagePreviews([]);
// //     };

// //     const handleDeleteModalClose = () => {
// //         setDeleteModalData({ show: false, id: null, name: "" });
// //     };

// //     const handleImagesModalClose = () => {
// //         setImagesModalData({ show: false, images: [], title: "" });
// //     };

// //     const handleEditFormChange = (e) => {
// //         const { name, value } = e.target;
// //         setEditModalData(prevData => ({
// //             ...prevData,
// //             [name]: value
// //         }));
// //     };

// //     const handleImageChange = (e) => {
// //         const files = Array.from(e.target.files);

// //         // Validate file types and sizes
// //         const validFiles = files.filter(file => {
// //             if (!file.type.startsWith('image/')) {
// //                 showToastMessage("Only image files are allowed.", "danger");
// //                 return false;
// //             }

// //             if (file.size > 5 * 1024 * 1024) {
// //                 showToastMessage("Image size should be less than 5MB.", "danger");
// //                 return false;
// //             }

// //             return true;
// //         });

// //         setNewImages(prevImages => [...prevImages, ...validFiles]);

// //         // Create previews
// //         const newPreviews = validFiles.map(file => URL.createObjectURL(file));
// //         setImagePreviews(prevPreviews => [...prevPreviews, ...newPreviews]);
// //     };

// //     const removeImage = (index, isExisting = false) => {
// //         if (isExisting) {
// //             setEditModalData(prev => ({
// //                 ...prev,
// //                 existing_images: prev.existing_images.filter((_, i) => i !== index)
// //             }));
// //         } else {
// //             const newIndex = index - editModalData.existing_images.length;
// //             setNewImages(prevImages => prevImages.filter((_, i) => i !== newIndex));
// //             setImagePreviews(prevPreviews => {
// //                 URL.revokeObjectURL(prevPreviews[index]);
// //                 return prevPreviews.filter((_, i) => i !== index);
// //             });
// //         }
// //     };

// //     const handleUpdateBankAccount = async (e) => {
// //         e.preventDefault();
// //         setActionLoading(true);
// //         const token = getAuthToken();

// //         try {
// //             // Create FormData object to send both form data and files
// //             const formDataToSend = new FormData();
// //             formDataToSend.append("id", editModalData.id);
// //             formDataToSend.append("payee", editModalData.payee);
// //             formDataToSend.append("type", editModalData.type);
// //             formDataToSend.append("existing_images", JSON.stringify(editModalData.existing_images));

// //             // Conditionally add online-only fields to the payload
// //             if (editModalData.type === "online") {
// //                 formDataToSend.append("bank_account_name", editModalData.bank_account_name);
// //                 formDataToSend.append("account_number", editModalData.account_number);
// //                 formDataToSend.append("ifsc_code", editModalData.ifsc_code);
// //             }

// //             // Append each new image file
// //             newImages.forEach((image, index) => {
// //                 formDataToSend.append(`images`, image);
// //             });

// //             const response = await fetch(`${API_URL}/expence-bank-account-update`, {
// //                 method: "POST",
// //                 headers: {
// //                     Authorization: `Bearer ${token}`,
// //                 },
// //                 body: formDataToSend,
// //             });

// //             const result = await response.json();
// //             if (result.success == "1") {
// //                 showToastMessage("Bank account updated successfully!", "success");
// //                 handleEditModalClose();
// //                 fetchBankAccounts();
// //             } else {
// //                 throw new Error(result.message || "Failed to update bank account.");
// //             }
// //         } catch (err) {
// //             console.error("Update error:", err);
// //             showToastMessage(err.message, "danger");
// //         } finally {
// //             setActionLoading(false);
// //         }
// //     };

// //     const handleDeleteBankAccount = async () => {
// //         setActionLoading(true);
// //         const token = getAuthToken();

// //         try {
// //             const response = await fetch(`${API_URL}/expence-bank-account-delete`, {
// //                 method: "POST",
// //                 headers: {
// //                     "Content-Type": "application/json",
// //                     Authorization: `Bearer ${token}`,
// //                 },
// //                 body: JSON.stringify({ id: deleteModalData.id }),
// //             });

// //             const result = await response.json();
// //             if (response.ok && result.status) {
// //                 showToastMessage("Bank account deleted successfully!", "success");
// //                 handleDeleteModalClose();
// //                 fetchBankAccounts();
// //             } else {
// //                 throw new Error(result.message || "Failed to delete bank account.");
// //             }
// //         } catch (err) {
// //             console.error("Delete error:", err);
// //             showToastMessage(err.message, "danger");
// //         } finally {
// //             setActionLoading(false);
// //         }
// //     };

// //     const handlePageChange = (pageNumber) => {
// //         if (pageNumber > 0 && pageNumber <= totalPages) {
// //             setCurrentPage(pageNumber);
// //             fetchBankAccounts(pageNumber);
// //         }
// //     };

// //     // return (
// //     //     <>
// //     //         <div className="card mt-2">
// //     //             <div className="card-header">
// //     //                 <div className="d-flex justify-content-between align-items-center">
// //     //                     <div className="titlepage">
// //     //                         <h3 className="mb-0">Bank Accounts</h3>
// //     //                     </div>
// //     //                     <Link to="/add-bankaccount" className="btn btn-primary">
// //     //                         <FaPlus className="me-2" />
// //     //                         Add Bank Account
// //     //                     </Link>
// //     //                 </div>
// //     //             </div>
// //     //             <div className="card-body">
// //     //                 {loading ? (
// //     //                     <div className="text-center mt-5">
// //     //                         <div className="spinner-border text-primary" role="status">
// //     //                             <span className="visually-hidden">Loading...</span>
// //     //                         </div>
// //     //                         <p>Loading bank accounts...</p>
// //     //                     </div>
// //     //                 ) : error ? (
// //     //                     <div className="alert alert-danger" role="alert">
// //     //                         {error}
// //     //                     </div>
// //     //                 ) : accounts?.length === 0 ? (
// //     //                     <div className="alert alert-info" role="alert">
// //     //                         No bank accounts found.
// //     //                     </div>
// //     //                 ) : (
// //     //                     <>
// //     //                         <Table striped bordered hover responsive>
// //     //                             <thead>
// //     //                                 <tr>
// //     //                                     <th>#</th>
// //     //                                     <th>Name</th>
// //     //                                     <th>Branch Name</th>
// //     //                                     <th>Bank</th>
// //     //                                     <th>Account Number</th>
// //     //                                     <th>IFSC Number</th>
// //     //                                     <th>Type</th>
// //     //                                     <th>Date</th>
// //     //                                     <th>Actions</th>
// //     //                                 </tr>
// //     //                             </thead>
// //     //                             <tbody>
// //     //                                 {accounts?.map((account, index) => (
// //     //                                     <tr key={account.id}>
// //     //                                         <td>{(currentPage - 1) * 10 + index + 1}</td>
// //     //                                         <td>
// //     //                                             {account.payee
// //     //                                                 ? account.payee.charAt(0).toUpperCase() + account.payee.slice(1).toLowerCase()
// //     //                                                 : ''}
// //     //                                         </td>

// //     //                                         <td>{account.bank_branch_name ||"NA" } </td>

// //     //                                         <td>
// //     //                                             {account.bank_account_name
// //     //                                                 ? account.bank_account_name.charAt(0).toUpperCase() + account.bank_account_name.slice(1).toLowerCase()
// //     //                                                 : '-'}
// //     //                                         </td>

// //     //                                         <td>{account.account_number || "-"}</td>
// //     //                                         <td>{account.ifsc_code || "-"}</td>
// //     //                                         <td style={{ color: "green" }}>
// //     //                                             {account.type.charAt(0).toUpperCase() + account.type.slice(1).toLowerCase()}
// //     //                                         </td>


// //     //                                         <td>{new Date(account.created_at).toLocaleDateString('en-GB').replace(/\//g, '-')}</td>
// //     //                                         <td>
// //     //                                             <div className="dropdown">
// //     //                                                 <button
// //     //                                                     className="btn light btn-action dropdown-toggle"
// //     //                                                     type="button"
// //     //                                                     id="dropdownMenuButton"
// //     //                                                     data-bs-toggle="dropdown"
// //     //                                                     aria-expanded="false"
// //     //                                                 >
// //     //                                                     <BsThreeDots size={20} />
// //     //                                                 </button>

// //     //                                                 <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
// //     //                                                     <li className="dropdown-item">
// //     //                                                         <button
// //     //                                                             className="btn edit_btn btn-sm me-1"
// //     //                                                             onClick={() => handleEditClick(account.id)}
// //     //                                                             title="Edit Account"
// //     //                                                         >
// //     //                                                             <FaEdit /> Edit
// //     //                                                         </button>
// //     //                                                     </li>
// //     //                                                     <li className="dropdown-item">
// //     //                                                         <button
// //     //                                                             className="btn delete_btn btn-sm"
// //     //                                                             onClick={() => handleDeleteClick(account)}
// //     //                                                             title="Delete Account"
// //     //                                                         >
// //     //                                                             <RiDeleteBin3Fill /> Delete
// //     //                                                         </button>
// //     //                                                     </li>
// //     //                                                 </ul>
// //     //                                             </div>
// //     //                                         </td>
// //     //                                     </tr>
// //     //                                 ))}
// //     //                             </tbody>
// //     //                         </Table>
// //     //                         <div className="d-flex justify-content-end">
// //     //                             <nav>
// //     //                                 <ul className="pagination">
// //     //                                     <li className="page-item">
// //     //                                         <button
// //     //                                             className="page-link"
// //     //                                             onClick={() => handlePageChange(currentPage - 1)}
// //     //                                             disabled={currentPage === 1}
// //     //                                             aria-label="Previous"
// //     //                                         >
// //     //                                             <HiOutlineChevronLeft />
// //     //                                         </button>
// //     //                                     </li>

// //     //                                     {[...Array(totalPages)].map((_, index) => (
// //     //                                         <li key={index + 1} className="page-item">
// //     //                                             <button
// //     //                                                 className={`page-link ${index + 1 === currentPage ? "active" : ""}`}
// //     //                                                 onClick={() => handlePageChange(index + 1)}
// //     //                                             >
// //     //                                                 {index + 1}
// //     //                                             </button>
// //     //                                         </li>
// //     //                                     ))}

// //     //                                     <li className="page-item">
// //     //                                         <button
// //     //                                             className="page-link"
// //     //                                             onClick={() => handlePageChange(currentPage + 1)}
// //     //                                             disabled={currentPage === totalPages}
// //     //                                             aria-label="Next"
// //     //                                         >
// //     //                                             <HiChevronRight />
// //     //                                         </button>
// //     //                                     </li>
// //     //                                 </ul>
// //     //                             </nav>
// //     //                         </div>
// //     //                     </>
// //     //                 )}
// //     //             </div>
// //     //         </div>

// //     //         {/* Edit Bank Account Modal */}
// //     //         <Modal show={editModalData.show} onHide={handleEditModalClose} size="lg">
// //     //             <Modal.Header closeButton>
// //     //                 <Modal.Title>Edit Bank Account</Modal.Title>
// //     //             </Modal.Header>
// //     //             <Form onSubmit={handleUpdateBankAccount}>
// //     //                 <Modal.Body>
// //     //                     <Form.Group className="mb-3">
// //     //                         <Form.Label>Payee</Form.Label>
// //     //                         <Form.Control
// //     //                             type="text"
// //     //                             name="payee"
// //     //                             value={editModalData.payee || ''}
// //     //                             onChange={handleEditFormChange}
// //     //                             required
// //     //                         />
// //     //                     </Form.Group>

// //     //                     {/* Conditionally render fields for 'online' type */}
// //     //                     {editModalData.type === 'online' && (
// //     //                         <>
// //     //                             <Form.Group className="mb-3">
// //     //                                 <Form.Label>Bank Name</Form.Label>
// //     //                                 <Form.Control
// //     //                                     type="text"
// //     //                                     name="bank_account_name"
// //     //                                     value={editModalData.bank_account_name || ''}
// //     //                                     onChange={handleEditFormChange}
// //     //                                     required
// //     //                                 />
// //     //                             </Form.Group>
// //     //                             <Form.Group className="mb-3">
// //     //                                 <Form.Label>Account Number</Form.Label>
// //     //                                 <Form.Control
// //     //                                     type="text"
// //     //                                     name="account_number"
// //     //                                     value={editModalData.account_number || ''}
// //     //                                     onChange={handleEditFormChange}
// //     //                                     required
// //     //                                 />
// //     //                             </Form.Group>
// //     //                             <Form.Group className="mb-3">
// //     //                                 <Form.Label>IFSC Code</Form.Label>
// //     //                                 <Form.Control
// //     //                                     type="text"
// //     //                                     name="ifsc_code"
// //     //                                     value={editModalData.ifsc_code || ''}
// //     //                                     onChange={handleEditFormChange}
// //     //                                     required
// //     //                                 />
// //     //                             </Form.Group>
// //     //                         </>
// //     //                     )}

// //     //                     {/* Account Type dropdown */}
// //     //                     <Form.Group className="mb-3">
// //     //                         <Form.Label>Account Type</Form.Label>
// //     //                         <Form.Control
// //     //                             as="select"
// //     //                             name="type"
// //     //                             value={editModalData.type || ''}
// //     //                             onChange={handleEditFormChange}
// //     //                             required
// //     //                         >
// //     //                             <option value="">Select Type</option>
// //     //                             <option value="online">Online</option>
// //     //                             <option value="cash">Cash</option>
// //     //                         </Form.Control>
// //     //                     </Form.Group>

// //     //                     {/* Image Upload Section */}
// //     //                     <Form.Group className="mb-3">
// //     //                         <Form.Label>Bank Passbook/Cheque Images</Form.Label>
// //     //                         <Form.Control
// //     //                             type="file"
// //     //                             multiple
// //     //                             accept="image/*"
// //     //                             onChange={handleImageChange}
// //     //                         />
// //     //                         <Form.Text className="text-muted">
// //     //                             You can select multiple images. Maximum file size: 5MB each.
// //     //                         </Form.Text>
// //     //                     </Form.Group>

// //     //                     {/* Image Previews */}
// //     //                     {(editModalData.existing_images.length > 0 || imagePreviews.length > 0) && (
// //     //                         <div className="mt-3">
// //     //                             <h6>Images:</h6>
// //     //                             <div className="d-flex flex-wrap gap-2">
// //     //                                 {editModalData.existing_images.map((image, index) => (
// //     //                                     <div key={`existing-${index}`} className="position-relative" style={{ width: '100px', height: '100px' }}>
// //     //                                         <img
// //     //                                             src={`${IMG_URL}/loanlead/${image}`}
// //     //                                             alt={`Existing ${index + 1}`}
// //     //                                             className="img-thumbnail"
// //     //                                             style={{ width: '100%', height: '100%', objectFit: 'cover' }}
// //     //                                         />
// //     //                                         <button
// //     //                                             type="button"
// //     //                                             className="btn-close position-absolute top-0 end-0 bg-white"
// //     //                                             style={{ padding: '0.25rem' }}
// //     //                                             onClick={() => removeImage(index, true)}
// //     //                                             aria-label="Remove image"
// //     //                                         />
// //     //                                     </div>
// //     //                                 ))}
// //     //                                 {imagePreviews.map((preview, index) => (
// //     //                                     <div key={`new-${index}`} className="position-relative" style={{ width: '100px', height: '100px' }}>
// //     //                                         <img
// //     //                                             src={preview}
// //     //                                             alt={`New ${index + 1}`}
// //     //                                             className="img-thumbnail"
// //     //                                             style={{ width: '100%', height: '100%', objectFit: 'cover' }}
// //     //                                         />
// //     //                                         <button
// //     //                                             type="button"
// //     //                                             className="btn-close position-absolute top-0 end-0 bg-white"
// //     //                                             style={{ padding: '0.25rem' }}
// //     //                                             onClick={() => removeImage(editModalData.existing_images.length + index, false)}
// //     //                                             aria-label="Remove image"
// //     //                                         />
// //     //                                     </div>
// //     //                                 ))}
// //     //                             </div>
// //     //                         </div>
// //     //                     )}
// //     //                 </Modal.Body>
// //     //                 <Modal.Footer>
// //     //                     <Button variant="danger" onClick={handleEditModalClose}>
// //     //                         Close
// //     //                     </Button>
// //     //                     <Button variant="primary" type="submit" disabled={actionLoading}>
// //     //                         {actionLoading ? "Updating..." : "Save Changes"}
// //     //                     </Button>
// //     //                 </Modal.Footer>
// //     //             </Form>
// //     //         </Modal>

// //     //         {/* Delete Confirmation Modal */}
// //     //         <Modal show={deleteModalData.show} onHide={handleDeleteModalClose}>
// //     //             <Modal.Header closeButton>
// //     //                 <Modal.Title>Confirm Deletion</Modal.Title>
// //     //             </Modal.Header>
// //     //             <Modal.Body>
// //     //                 Are you sure you want to delete the bank account for "<strong>{deleteModalData.name}</strong>"? This action cannot be undone.
// //     //             </Modal.Body>
// //     //             <Modal.Footer>
// //     //                 <Button variant="secondary" onClick={handleDeleteModalClose}>
// //     //                     Cancel
// //     //                 </Button>
// //     //                 <Button variant="danger" onClick={handleDeleteBankAccount} disabled={actionLoading}>
// //     //                     {actionLoading ? "Deleting..." : "Delete"}
// //     //                 </Button>
// //     //             </Modal.Footer>
// //     //         </Modal>

// //     //         {/* Images View Modal */}
// //     //         <Modal show={imagesModalData.show} onHide={handleImagesModalClose} size="lg">
// //     //             <Modal.Header closeButton>
// //     //                 <Modal.Title>{imagesModalData.title}</Modal.Title>
// //     //             </Modal.Header>
// //     //             <Modal.Body>
// //     //                 {imagesModalData.images.length > 0 ? (
// //     //                     <Carousel>
// //     //                         {imagesModalData.images.map((image, index) => (
// //     //                             <Carousel.Item key={index}>
// //     //                                 <div className="d-flex justify-content-center">
// //     //                                     <img
// //     //                                         className="d-block"
// //     //                                         src={`${IMG_URL}/loanlead/${image}`}
// //     //                                         alt={`Bank document ${index + 1}`}
// //     //                                         style={{ maxHeight: '400px', maxWidth: '100%' }}
// //     //                                     />
// //     //                                 </div>
// //     //                             </Carousel.Item>
// //     //                         ))}
// //     //                     </Carousel>
// //     //                 ) : (
// //     //                     <p className="text-center">No images available</p>
// //     //                 )}
// //     //             </Modal.Body>
// //     //             <Modal.Footer>
// //     //                 <Button variant="secondary" onClick={handleImagesModalClose}>
// //     //                     Close
// //     //                 </Button>
// //     //             </Modal.Footer>
// //     //         </Modal>

// //     //         {showToast && (
// //     //             <div
// //     //                 className={`toast show bg-${toastVariant} text-white`}
// //     //                 style={{ position: "fixed", bottom: "20px", right: "20px" }}
// //     //                 role="alert"
// //     //                 aria-live="assertive"
// //     //                 aria-atomic="true"
// //     //             >
// //     //                 <div className="toast-header bg-transparent text-white border-0">
// //     //                     <strong className="me-auto">{toastVariant === 'success' ? 'Success' : 'Error'}</strong>
// //     //                     <button
// //     //                         type="button"
// //     //                         className="btn-close btn-close-white"
// //     //                         onClick={() => setShowToast(false)}
// //     //                         aria-label="Close"
// //     //                     ></button>
// //     //                 </div>
// //     //                 <div className="toast-body">{toastMessage}</div>
// //     //             </div>
// //     //         )}
// //     //     </>
// //     // );

// //       return (
// //     <>
// //       <div
// //         style={{
// //           minHeight: "100vh",
// //           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
// //           padding: "30px 24px",
// //           fontFamily: "'Poppins', 'DM Sans', sans-serif",
// //         }}
// //       >
// //         <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
// //           {/* 🎯 HEADER CARD */}
// //           <div
// //             style={{
// //               background: "#ffffff",
// //               borderRadius: "16px",
// //               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
// //               border: "1.5px solid #e2e8f0",
// //               padding: "20px 24px",
// //               display: "flex",
// //               alignItems: "center",
// //               gap: "16px",
// //               marginBottom: "20px",
// //               flexWrap: "wrap",
// //             }}
// //           >
// //             <div
// //               style={{
// //                 width: "52px",
// //                 height: "52px",
// //                 borderRadius: "14px",
// //                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
// //                 display: "flex",
// //                 alignItems: "center",
// //                 justifyContent: "center",
// //                 color: "#ffffff",
// //                 fontSize: "24px",
// //                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
// //                 flexShrink: 0,
// //               }}
// //             >
// //               🏦
// //             </div>
// //             <div style={{ flex: 1, minWidth: "200px" }}>
// //               <h1
// //                 style={{
// //                   margin: 0,
// //                   fontSize: "24px",
// //                   fontWeight: "800",
// //                   color: "#1e3a5f",
// //                   letterSpacing: "-0.5px",
// //                 }}
// //               >
// //                 Bank Accounts
// //               </h1>
// //               <p
// //                 style={{
// //                   margin: "2px 0 0",
// //                   fontSize: "13px",
// //                   color: "#64748b",
// //                   fontWeight: "500",
// //                 }}
// //               >
// //                 Manage all your bank accounts in one place
// //               </p>
// //             </div>

// //             <Link to="/add-bankaccount" className="btn btn-primary">
// //               <FaPlus className="me-2" /> Add Bank Account
// //             </Link>
// //           </div>

// //           {/* 🎯 MAIN CARD */}
// //           <div
// //             style={{
// //               background: "#ffffff",
// //               borderRadius: "16px",
// //               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
// //               border: "1.5px solid #e2e8f0",
// //               overflow: "hidden",
// //             }}
// //           >
// //             <div
// //               style={{
// //                 height: "5px",
// //                 background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
// //               }}
// //             />

// //             <div style={{ padding: "30px" }}>
// //               {loading ? (
// //                 <div className="text-center my-5">
// //                   <div className="spinner-border text-primary" role="status">
// //                     <span className="visually-hidden">Loading...</span>
// //                   </div>
// //                   <p className="mt-3">Loading bank accounts...</p>
// //                 </div>
// //               ) : error ? (
// //                 <div className="alert alert-danger" role="alert">
// //                   {error}
// //                 </div>
// //               ) : accounts?.length === 0 ? (
// //                 <div className="alert alert-info" role="alert">
// //                   No bank accounts found.
// //                 </div>
// //               ) : (
// //                 <>
// //                   <Table striped bordered hover responsive>
// //                     <thead>
// //                       <tr>
// //                         <th>#</th>
// //                         <th>Name</th>
// //                         <th>Branch Name</th>
// //                         <th>Bank</th>
// //                         <th>Account Number</th>
// //                         <th>IFSC Number</th>
// //                         <th>Type</th>
// //                         <th>Date</th>
// //                         <th>Actions</th>
// //                       </tr>
// //                     </thead>
// //                     <tbody>
// //                       {accounts?.map((account, index) => (
// //                         <tr key={account.id}>
// //                           <td>{(currentPage - 1) * 10 + index + 1}</td>
// //                           <td>
// //                             {account.payee
// //                               ? account.payee.charAt(0).toUpperCase() +
// //                                 account.payee.slice(1).toLowerCase()
// //                               : ""}
// //                           </td>

// //                           <td>{account.bank_branch_name || "NA"} </td>

// //                           <td>
// //                             {account.bank_account_name
// //                               ? account.bank_account_name
// //                                   .charAt(0)
// //                                   .toUpperCase() +
// //                                 account.bank_account_name.slice(1).toLowerCase()
// //                               : "-"}
// //                           </td>

// //                           <td>{account.account_number || "-"}</td>
// //                           <td>{account.ifsc_code || "-"}</td>
// //                           <td style={{ color: "green" }}>
// //                             {account.type.charAt(0).toUpperCase() +
// //                               account.type.slice(1).toLowerCase()}
// //                           </td>

// //                           <td>
// //                             {new Date(account.created_at)
// //                               .toLocaleDateString("en-GB")
// //                               .replace(/\//g, "-")}
// //                           </td>
// //                           <td>
// //                             <div className="dropdown">
// //                               <button
// //                                 className="btn light btn-action dropdown-toggle"
// //                                 type="button"
// //                                 id="dropdownMenuButton"
// //                                 data-bs-toggle="dropdown"
// //                                 aria-expanded="false"
// //                               >
// //                                 <BsThreeDots size={20} />
// //                               </button>

// //                               <ul
// //                                 className="dropdown-menu"
// //                                 aria-labelledby="dropdownMenuButton"
// //                               >
// //                                 <li className="dropdown-item">
// //                                   <button
// //                                     className="btn edit_btn btn-sm me-1"
// //                                     onClick={() => handleEditClick(account.id)}
// //                                     title="Edit Account"
// //                                   >
// //                                     <FaEdit /> Edit
// //                                   </button>
// //                                 </li>
// //                                 <li className="dropdown-item">
// //                                   <button
// //                                     className="btn delete_btn btn-sm"
// //                                     onClick={() => handleDeleteClick(account)}
// //                                     title="Delete Account"
// //                                   >
// //                                     <RiDeleteBin3Fill /> Delete
// //                                   </button>
// //                                 </li>
// //                               </ul>
// //                             </div>
// //                           </td>
// //                         </tr>
// //                       ))}
// //                     </tbody>
// //                   </Table>

// //                   <div className="d-flex justify-content-end">
// //                     <nav>
// //                       <ul className="pagination">
// //                         <li className="page-item">
// //                           <button
// //                             className="page-link"
// //                             onClick={() =>
// //                               handlePageChange(currentPage - 1)
// //                             }
// //                             disabled={currentPage === 1}
// //                             aria-label="Previous"
// //                           >
// //                             <HiOutlineChevronLeft />
// //                           </button>
// //                         </li>

// //                         {[...Array(totalPages)].map((_, index) => (
// //                           <li key={index + 1} className="page-item">
// //                             <button
// //                               className={`page-link ${
// //                                 index + 1 === currentPage ? "active" : ""
// //                               }`}
// //                               onClick={() => handlePageChange(index + 1)}
// //                             >
// //                               {index + 1}
// //                             </button>
// //                           </li>
// //                         ))}

// //                         <li className="page-item">
// //                           <button
// //                             className="page-link"
// //                             onClick={() =>
// //                               handlePageChange(currentPage + 1)
// //                             }
// //                             disabled={currentPage === totalPages}
// //                             aria-label="Next"
// //                           >
// //                             <HiChevronRight />
// //                           </button>
// //                         </li>
// //                       </ul>
// //                     </nav>
// //                   </div>
// //                 </>
// //               )}
// //             </div>
// //           </div>

// //           {/* Footer Copyright */}
// //           <p
// //             style={{
// //               textAlign: "center",
// //               color: "#94a3b8",
// //               fontSize: "12.5px",
// //               marginTop: "24px",
// //               fontWeight: "500",
// //             }}
// //           >
// //             © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
// //             Rights Reserved.
// //           </p>
// //         </div>
// //       </div>

// //       {/* Edit Bank Account Modal */}
// //       <Modal show={editModalData.show} onHide={handleEditModalClose} size="lg">
// //         <Modal.Header closeButton>
// //           <Modal.Title>Edit Bank Account</Modal.Title>
// //         </Modal.Header>
// //         <Form onSubmit={handleUpdateBankAccount}>
// //           <Modal.Body>
// //             <Form.Group className="mb-3">
// //               <Form.Label>Payee</Form.Label>
// //               <Form.Control
// //                 type="text"
// //                 name="payee"
// //                 value={editModalData.payee || ""}
// //                 onChange={handleEditFormChange}
// //                 required
// //               />
// //             </Form.Group>

// //             {editModalData.type === "online" && (
// //               <>
// //                 <Form.Group className="mb-3">
// //                   <Form.Label>Bank Name</Form.Label>
// //                   <Form.Control
// //                     type="text"
// //                     name="bank_account_name"
// //                     value={editModalData.bank_account_name || ""}
// //                     onChange={handleEditFormChange}
// //                     required
// //                   />
// //                 </Form.Group>
// //                 <Form.Group className="mb-3">
// //                   <Form.Label>Account Number</Form.Label>
// //                   <Form.Control
// //                     type="text"
// //                     name="account_number"
// //                     value={editModalData.account_number || ""}
// //                     onChange={handleEditFormChange}
// //                     required
// //                   />
// //                 </Form.Group>
// //                 <Form.Group className="mb-3">
// //                   <Form.Label>IFSC Code</Form.Label>
// //                   <Form.Control
// //                     type="text"
// //                     name="ifsc_code"
// //                     value={editModalData.ifsc_code || ""}
// //                     onChange={handleEditFormChange}
// //                     required
// //                   />
// //                 </Form.Group>
// //               </>
// //             )}

// //             <Form.Group className="mb-3">
// //               <Form.Label>Account Type</Form.Label>
// //               <Form.Control
// //                 as="select"
// //                 name="type"
// //                 value={editModalData.type || ""}
// //                 onChange={handleEditFormChange}
// //                 required
// //               >
// //                 <option value="">Select Type</option>
// //                 <option value="online">Online</option>
// //                 <option value="cash">Cash</option>
// //               </Form.Control>
// //             </Form.Group>

// //             <Form.Group className="mb-3">
// //               <Form.Label>Bank Passbook/Cheque Images</Form.Label>
// //               <Form.Control
// //                 type="file"
// //                 multiple
// //                 accept="image/*"
// //                 onChange={handleImageChange}
// //               />
// //               <Form.Text className="text-muted">
// //                 You can select multiple images. Maximum file size: 5MB each.
// //               </Form.Text>
// //             </Form.Group>

// //             {(editModalData.existing_images.length > 0 ||
// //               imagePreviews.length > 0) && (
// //               <div className="mt-3">
// //                 <h6>Images:</h6>
// //                 <div className="d-flex flex-wrap gap-2">
// //                   {editModalData.existing_images.map((image, index) => (
// //                     <div
// //                       key={`existing-${index}`}
// //                       className="position-relative"
// //                       style={{ width: "100px", height: "100px" }}
// //                     >
// //                       <img
// //                         src={`${IMG_URL}/loanlead/${image}`}
// //                         alt={`Existing ${index + 1}`}
// //                         className="img-thumbnail"
// //                         style={{
// //                           width: "100%",
// //                           height: "100%",
// //                           objectFit: "cover",
// //                         }}
// //                       />
// //                       <button
// //                         type="button"
// //                         className="btn-close position-absolute top-0 end-0 bg-white"
// //                         style={{ padding: "0.25rem" }}
// //                         onClick={() => removeImage(index, true)}
// //                         aria-label="Remove image"
// //                       />
// //                     </div>
// //                   ))}
// //                   {imagePreviews.map((preview, index) => (
// //                     <div
// //                       key={`new-${index}`}
// //                       className="position-relative"
// //                       style={{ width: "100px", height: "100px" }}
// //                     >
// //                       <img
// //                         src={preview}
// //                         alt={`New ${index + 1}`}
// //                         className="img-thumbnail"
// //                         style={{
// //                           width: "100%",
// //                           height: "100%",
// //                           objectFit: "cover",
// //                         }}
// //                       />
// //                       <button
// //                         type="button"
// //                         className="btn-close position-absolute top-0 end-0 bg-white"
// //                         style={{ padding: "0.25rem" }}
// //                         onClick={() =>
// //                           removeImage(
// //                             editModalData.existing_images.length + index,
// //                             false,
// //                           )
// //                         }
// //                         aria-label="Remove image"
// //                       />
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>
// //             )}
// //           </Modal.Body>
// //           <Modal.Footer>
// //             <Button variant="danger" onClick={handleEditModalClose}>
// //               Close
// //             </Button>
// //             <Button variant="primary" type="submit" disabled={actionLoading}>
// //               {actionLoading ? "Updating..." : "Save Changes"}
// //             </Button>
// //           </Modal.Footer>
// //         </Form>
// //       </Modal>

// //       {/* Delete Confirmation Modal */}
// //       <Modal show={deleteModalData.show} onHide={handleDeleteModalClose}>
// //         <Modal.Header closeButton>
// //           <Modal.Title>Confirm Deletion</Modal.Title>
// //         </Modal.Header>
// //         <Modal.Body>
// //           Are you sure you want to delete the bank account for "
// //           <strong>{deleteModalData.name}</strong>"? This action cannot be
// //           undone.
// //         </Modal.Body>
// //         <Modal.Footer>
// //           <Button variant="secondary" onClick={handleDeleteModalClose}>
// //             Cancel
// //           </Button>
// //           <Button
// //             variant="danger"
// //             onClick={handleDeleteBankAccount}
// //             disabled={actionLoading}
// //           >
// //             {actionLoading ? "Deleting..." : "Delete"}
// //           </Button>
// //         </Modal.Footer>
// //       </Modal>

// //       {/* Images View Modal */}
// //       <Modal
// //         show={imagesModalData.show}
// //         onHide={handleImagesModalClose}
// //         size="lg"
// //       >
// //         <Modal.Header closeButton>
// //           <Modal.Title>{imagesModalData.title}</Modal.Title>
// //         </Modal.Header>
// //         <Modal.Body>
// //           {imagesModalData.images.length > 0 ? (
// //             <Carousel>
// //               {imagesModalData.images.map((image, index) => (
// //                 <Carousel.Item key={index}>
// //                   <div className="d-flex justify-content-center">
// //                     <img
// //                       className="d-block"
// //                       src={`${IMG_URL}/loanlead/${image}`}
// //                       alt={`Bank document ${index + 1}`}
// //                       style={{ maxHeight: "400px", maxWidth: "100%" }}
// //                     />
// //                   </div>
// //                 </Carousel.Item>
// //               ))}
// //             </Carousel>
// //           ) : (
// //             <p className="text-center">No images available</p>
// //           )}
// //         </Modal.Body>
// //         <Modal.Footer>
// //           <Button variant="secondary" onClick={handleImagesModalClose}>
// //             Close
// //           </Button>
// //         </Modal.Footer>
// //       </Modal>

// //       {/* Toast */}
// //       {showToast && (
// //         <div
// //           className={`toast show bg-${toastVariant} text-white`}
// //           style={{
// //             position: "fixed",
// //             bottom: "20px",
// //             right: "20px",
// //             zIndex: 9999,
// //             borderRadius: "12px",
// //             overflow: "hidden",
// //             boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
// //           }}
// //           role="alert"
// //           aria-live="assertive"
// //           aria-atomic="true"
// //         >
// //           <div className="toast-header bg-transparent text-white border-0">
// //             <strong className="me-auto">
// //               {toastVariant === "success" ? "Success" : "Error"}
// //             </strong>
// //             <button
// //               type="button"
// //               className="btn-close btn-close-white"
// //               onClick={() => setShowToast(false)}
// //               aria-label="Close"
// //             ></button>
// //           </div>
// //           <div className="toast-body">{toastMessage}</div>
// //         </div>
// //       )}
// //     </>
// //   );
  
// // }

// // export default BankAccountList;

// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { FaPlus, FaEdit } from "react-icons/fa";
// import { Modal, Button, Form, Row, Col, Carousel } from "react-bootstrap";
// import { RiDeleteBin3Fill } from "react-icons/ri";
// import { BsThreeDots } from "react-icons/bs";
// import Swal from "sweetalert2";

// const API_URL = process.env.REACT_APP_API_URL;
// const IMG_URL = process.env.REACT_APP_Image_URL;
// const LIMIT = 10;

// function BankAccountList() {
//   const navigate = useNavigate();
//   const [accounts, setAccounts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalItems, setTotalItems] = useState(0);
//   const [actionLoading, setActionLoading] = useState(false);

//   const [editModalData, setEditModalData] = useState({
//     show: false,
//     id: null,
//     payee: "",
//     bank_account_name: "",
//     account_number: "",
//     ifsc_code: "",
//     type: "",
//     images: [],
//     existing_images: [],
//   });

//   const [deleteModalData, setDeleteModalData] = useState({
//     show: false,
//     id: null,
//     name: "",
//   });

//   const [imagesModalData, setImagesModalData] = useState({
//     show: false,
//     images: [],
//     title: "",
//   });

//   const [newImages, setNewImages] = useState([]);
//   const [imagePreviews, setImagePreviews] = useState([]);

//   const getAuthToken = () => localStorage.getItem("token");

//   // ═══════════════════════════════════════════
//   // 🔹 FETCH BANK ACCOUNTS (Server-Side Pagination)
//   // ═══════════════════════════════════════════
//   const fetchBankAccounts = async (page = 1) => {
//     setLoading(true);
//     const token = getAuthToken();
//     if (!token) {
//       setError("Authentication token not found. Please log in.");
//       setLoading(false);
//       return;
//     }

//     try {
//       const response = await fetch(
//         `${API_URL}/expence-bank-account-list?page=${page}&limit=${LIMIT}`,
//         {
//           method: "GET",
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       if (!response.ok) {
//         if (response.status === 401) navigate("/login");
//         throw new Error("Failed to fetch bank accounts.");
//       }

//       const data = await response.json();
//       if (data.status) {
//         const accountsWithImages = (data.data || []).map((account) => ({
//           ...account,
//           images: account.image ? account.image.split(",") : [],
//         }));
//         setAccounts(accountsWithImages);

//         const pages = Number(data.totalPages) || 1;
//         const total = Number(data.total) || (data.data?.length || 0);

//         setTotalPages(pages);
//         setTotalItems(total);
//         setCurrentPage(Number(data.currentPage) || Number(page));
//       } else {
//         setError(data.message || "No bank accounts found.");
//         setAccounts([]);
//       }
//     } catch (err) {
//       console.error("Fetch error:", err);
//       setError(err.message);
//       setAccounts([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchBankAccounts(currentPage);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [currentPage]);

//   const handlePageChange = (pageNumber) => {
//     if (pageNumber < 1 || pageNumber > totalPages) return;
//     setCurrentPage(pageNumber);
//   };

//   // ═══════════════════════════════════════════
//   // 🔹 EDIT
//   // ═══════════════════════════════════════════
//   const handleEditClick = async (id) => {
//     setActionLoading(true);
//     const token = getAuthToken();
//     if (!token) {
//       Swal.fire("Error", "Authentication token not found.", "error");
//       setActionLoading(false);
//       return;
//     }
//     try {
//       const response = await fetch(`${API_URL}/expence-bank-account-edit`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ id }),
//       });
//       const result = await response.json();
//       if (response.ok && result.status) {
//         setEditModalData({
//           show: true,
//           id: result.data.id,
//           payee: result.data.payee || "",
//           bank_account_name: result.data.bank_account_name || "",
//           account_number: result.data.account_number || "",
//           ifsc_code: result.data.ifsc_code || "",
//           type: result.data.type || "",
//           images: result.data.images || [],
//           existing_images: result.data.images || [],
//         });
//         setNewImages([]);
//         setImagePreviews([]);
//       } else {
//         throw new Error(result.message || "Failed to fetch account details.");
//       }
//     } catch (err) {
//       console.error("Edit fetch error:", err);
//       Swal.fire("Error", err.message, "error");
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const handleEditFormChange = (e) => {
//     const { name, value } = e.target;
//     setEditModalData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleImageChange = (e) => {
//     const files = Array.from(e.target.files);
//     const validFiles = files.filter((file) => {
//       if (!file.type.startsWith("image/")) {
//         Swal.fire("Warning", "Only image files are allowed.", "warning");
//         return false;
//       }
//       if (file.size > 5 * 1024 * 1024) {
//         Swal.fire("Warning", "Image size should be less than 5MB.", "warning");
//         return false;
//       }
//       return true;
//     });

//     setNewImages((prev) => [...prev, ...validFiles]);
//     const newPreviews = validFiles.map((file) => URL.createObjectURL(file));
//     setImagePreviews((prev) => [...prev, ...newPreviews]);
//   };

//   const removeImage = (index, isExisting = false) => {
//     if (isExisting) {
//       setEditModalData((prev) => ({
//         ...prev,
//         existing_images: prev.existing_images.filter((_, i) => i !== index),
//       }));
//     } else {
//       const newIndex = index - editModalData.existing_images.length;
//       setNewImages((prev) => prev.filter((_, i) => i !== newIndex));
//       setImagePreviews((prev) => {
//         URL.revokeObjectURL(prev[index]);
//         return prev.filter((_, i) => i !== index);
//       });
//     }
//   };

//   const handleUpdateBankAccount = async (e) => {
//     e.preventDefault();
//     setActionLoading(true);
//     const token = getAuthToken();

//     try {
//       const formDataToSend = new FormData();
//       formDataToSend.append("id", editModalData.id);
//       formDataToSend.append("payee", editModalData.payee);
//       formDataToSend.append("type", editModalData.type);
//       formDataToSend.append(
//         "existing_images",
//         JSON.stringify(editModalData.existing_images)
//       );

//       if (editModalData.type === "online") {
//         formDataToSend.append(
//           "bank_account_name",
//           editModalData.bank_account_name
//         );
//         formDataToSend.append("account_number", editModalData.account_number);
//         formDataToSend.append("ifsc_code", editModalData.ifsc_code);
//       }

//       newImages.forEach((image) => {
//         formDataToSend.append(`images`, image);
//       });

//       const response = await fetch(`${API_URL}/expence-bank-account-update`, {
//         method: "POST",
//         headers: { Authorization: `Bearer ${token}` },
//         body: formDataToSend,
//       });

//       const result = await response.json();
//       if (result.success == "1") {
//         Swal.fire(
//           "Success",
//           "Bank account updated successfully!",
//           "success"
//         );
//         handleEditModalClose();
//         fetchBankAccounts(currentPage);
//       } else {
//         throw new Error(result.message || "Failed to update bank account.");
//       }
//     } catch (err) {
//       console.error("Update error:", err);
//       Swal.fire("Error", err.message, "error");
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const handleEditModalClose = () => {
//     setEditModalData({
//       show: false,
//       id: null,
//       payee: "",
//       bank_account_name: "",
//       account_number: "",
//       ifsc_code: "",
//       type: "",
//       images: [],
//       existing_images: [],
//     });
//     setNewImages([]);
//     setImagePreviews([]);
//   };

//   // ═══════════════════════════════════════════
//   // 🔹 DELETE
//   // ═══════════════════════════════════════════
//   const handleDeleteClick = (account) => {
//     setDeleteModalData({
//       show: true,
//       id: account.id,
//       name: account.payee,
//     });
//   };

//   const handleDeleteModalClose = () => {
//     setDeleteModalData({ show: false, id: null, name: "" });
//   };

//   const handleDeleteBankAccount = async () => {
//     setActionLoading(true);
//     const token = getAuthToken();

//     try {
//       const response = await fetch(`${API_URL}/expence-bank-account-delete`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ id: deleteModalData.id }),
//       });

//       const result = await response.json();
//       if (response.ok && result.status) {
//         Swal.fire(
//           "Success",
//           "Bank account deleted successfully!",
//           "success"
//         );
//         handleDeleteModalClose();
//         fetchBankAccounts(currentPage);
//       } else {
//         throw new Error(result.message || "Failed to delete bank account.");
//       }
//     } catch (err) {
//       console.error("Delete error:", err);
//       Swal.fire("Error", err.message, "error");
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   // ═══════════════════════════════════════════
//   // 🔹 IMAGES VIEW
//   // ═══════════════════════════════════════════
//   const handleViewImagesClick = (account) => {
//     setImagesModalData({
//       show: true,
//       images: account.images,
//       title: `Images for ${account.payee}`,
//     });
//   };

//   const handleImagesModalClose = () => {
//     setImagesModalData({ show: false, images: [], title: "" });
//   };

//   // ═══════════════════════════════════════════
//   // 🔹 PAGINATION PAGES
//   // ═══════════════════════════════════════════
//   const getPageNumbers = () => {
//     const pages = [];
//     const showEllipsis = totalPages > 7;

//     pages.push(1);
//     if (showEllipsis && currentPage > 4) pages.push("left-ellipsis");

//     const start = Math.max(2, currentPage - 2);
//     const end = Math.min(totalPages - 1, currentPage + 2);

//     for (let i = start; i <= end; i++) pages.push(i);

//     if (showEllipsis && currentPage < totalPages - 3) pages.push("right-ellipsis");
//     if (totalPages > 1) pages.push(totalPages);

//     return pages;
//   };

//   // ═══════════════════════════════════════════
//   // 🎨 UI RENDER
//   // ═══════════════════════════════════════════
//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//         padding: "24px",
//         fontFamily: "'Poppins', 'DM Sans', sans-serif",
//       }}
//     >
//       <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
//         <div
//           style={{
//             background: "#ffffff",
//             borderRadius: "20px",
//             boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
//             border: "1.5px solid #e2e8f0",
//             overflow: "hidden",
//           }}
//         >
//           {/* Top Gradient */}
//           <div
//             style={{
//               height: "5px",
//               background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//             }}
//           />

//           {/* Header */}
//           <div
//             style={{
//               padding: "24px 30px",
//               background: "linear-gradient(135deg, #ffffff, #f8fafc)",
//               borderBottom: "1.5px solid #e2e8f0",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               gap: "16px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
//               <div
//                 style={{
//                   width: "48px",
//                   height: "48px",
//                   borderRadius: "14px",
//                   background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   color: "#ffffff",
//                   fontSize: "22px",
//                   boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                   flexShrink: 0,
//                 }}
//               >
//                 🏦
//               </div>
//               <div>
//                 <h2
//                   style={{
//                     margin: 0,
//                     fontSize: "22px",
//                     fontWeight: "800",
//                     color: "#1e3a5f",
//                   }}
//                 >
//                   Bank Accounts
//                 </h2>
//                 <p
//                   style={{
//                     margin: "2px 0 0",
//                     fontSize: "12.5px",
//                     color: "#64748b",
//                     fontWeight: "500",
//                   }}
//                 >
//                   Manage all your bank accounts ({totalItems} total)
//                 </p>
//               </div>
//             </div>

//             <Link
//               to="/add-bankaccount"
//               style={{
//                 padding: "10px 18px",
//                 borderRadius: "10px",
//                 border: "none",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 color: "#ffffff",
//                 fontSize: "13px",
//                 fontWeight: "700",
//                 textDecoration: "none",
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
//               }}
//             >
//               <FaPlus /> Add Bank Account
//             </Link>
//           </div>

//           {/* Body */}
//           <div style={{ padding: "24px 30px" }}>
//             {/* Loading */}
//             {loading ? (
//               <div
//                 style={{
//                   textAlign: "center",
//                   padding: "60px 20px",
//                   color: "#64748b",
//                 }}
//               >
//                 <div
//                   style={{
//                     width: "40px",
//                     height: "40px",
//                     border: "3px solid #cbd5e1",
//                     borderTop: "3px solid #2b6cb0",
//                     borderRadius: "50%",
//                     display: "inline-block",
//                     animation: "spin 0.8s linear infinite",
//                   }}
//                 />
//                 <p
//                   style={{
//                     marginTop: "16px",
//                     fontSize: "14px",
//                     fontWeight: "600",
//                   }}
//                 >
//                   Loading bank accounts...
//                 </p>
//               </div>
//             ) : error ? (
//               <div
//                 style={{
//                   background: "#feeaeb",
//                   border: "1.5px solid #fecaca",
//                   color: "#991b1b",
//                   borderRadius: "12px",
//                   padding: "14px 18px",
//                   fontWeight: "600",
//                   fontSize: "13.5px",
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   gap: "12px",
//                 }}
//               >
//                 <span>⚠️ {error}</span>
//                 <button
//                   onClick={() => fetchBankAccounts()}
//                   style={{
//                     padding: "6px 14px",
//                     borderRadius: "8px",
//                     border: "none",
//                     background: "#dc2626",
//                     color: "#ffffff",
//                     fontWeight: "700",
//                     fontSize: "12px",
//                     cursor: "pointer",
//                   }}
//                 >
//                   Retry
//                 </button>
//               </div>
//             ) : accounts.length === 0 ? (
//               <div
//                 style={{
//                   textAlign: "center",
//                   padding: "50px",
//                   color: "#94a3b8",
//                   fontWeight: "600",
//                 }}
//               >
//                 📭 No bank accounts found.
//               </div>
//             ) : (
//               <>
//                 <div
//                   style={{
//                     overflowX: "auto",
//                     overflowY: "visible",
//                     borderRadius: "14px",
//                     border: "1.5px solid #e2e8f0",
//                   }}
//                 >
//                   <table
//                     style={{
//                       width: "100%",
//                       minWidth: "1100px",
//                       borderCollapse: "collapse",
//                       fontSize: "13px",
//                     }}
//                   >
//                     <thead>
//                       <tr
//                         style={{
//                           background:
//                             "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                         }}
//                       >
//                         {[
//                           "S.N",
//                           "Payee Name",
//                           "Branch Name",
//                           "Bank Name",
//                           "Account Number",
//                           "IFSC Code",
//                           "Type",
//                           "Date",
//                           "Actions",
//                         ].map((th, i) => (
//                           <th
//                             key={i}
//                             style={{
//                               padding: "14px 12px",
//                               color: "#ffffff",
//                               fontWeight: "700",
//                               fontSize: "11.5px",
//                               textAlign: "left",
//                               letterSpacing: "0.5px",
//                               textTransform: "uppercase",
//                               whiteSpace: "nowrap",
//                             }}
//                           >
//                             {th}
//                           </th>
//                         ))}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {accounts.map((account, index) => (
//                         <tr
//                           key={account.id}
//                           style={{ borderBottom: "1px solid #f1f5f9" }}
//                           onMouseEnter={(e) =>
//                             (e.currentTarget.style.background = "#f8fafc")
//                           }
//                           onMouseLeave={(e) =>
//                             (e.currentTarget.style.background = "transparent")
//                           }
//                         >
//                           <td style={cellBlue}>
//                             {(currentPage - 1) * LIMIT + index + 1}
//                           </td>
//                           <td style={cellDark}>
//                             {account.payee
//                               ? account.payee.charAt(0).toUpperCase() +
//                                 account.payee.slice(1).toLowerCase()
//                               : "-"}
//                           </td>
//                           <td style={cellGray}>
//                             {account.bank_branch_name || "NA"}
//                           </td>
//                           <td style={cellDark}>
//                             {account.bank_account_name
//                               ? account.bank_account_name
//                                   .charAt(0)
//                                   .toUpperCase() +
//                                 account.bank_account_name.slice(1).toLowerCase()
//                               : "-"}
//                           </td>
//                           <td style={cellGray}>
//                             {account.account_number || "-"}
//                           </td>
//                           <td style={cellGray}>{account.ifsc_code || "-"}</td>
//                           <td style={{ padding: "12px" }}>
//                             <span
//                               style={{
//                                 display: "inline-block",
//                                 padding: "4px 12px",
//                                 borderRadius: "20px",
//                                 fontSize: "11.5px",
//                                 fontWeight: "700",
//                                 background:
//                                   account.type === "online"
//                                     ? "#e8f1fb"
//                                     : "#e7f9eb",
//                                 color:
//                                   account.type === "online"
//                                     ? "#1e5799"
//                                     : "#059669",
//                                 textTransform: "capitalize",
//                               }}
//                             >
//                               {account.type
//                                 ? account.type.charAt(0).toUpperCase() +
//                                   account.type.slice(1).toLowerCase()
//                                 : "-"}
//                             </span>
//                           </td>
//                           <td style={{ ...cellGray, whiteSpace: "nowrap" }}>
//                             {account.created_at
//                               ? new Date(account.created_at)
//                                   .toLocaleDateString("en-GB")
//                                   .replace(/\//g, "-")
//                               : "-"}
//                           </td>
//                           <td style={{ padding: "12px" }}>
//                             <div className="dropdown">
//                               <button
//                                 className="btn dropdown-toggle"
//                                 type="button"
//                                 data-bs-toggle="dropdown"
//                                 data-bs-boundary="viewport"
//                                 data-bs-popper-config='{"strategy":"fixed"}'
//                                 aria-expanded="false"
//                                 style={{
//                                   background: "#f8fafc",
//                                   border: "1.5px solid #e2e8f0",
//                                   borderRadius: "8px",
//                                   width: "36px",
//                                   height: "36px",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   justifyContent: "center",
//                                   color: "#1e5799",
//                                   padding: 0,
//                                 }}
//                               >
//                                 <BsThreeDots size={18} />
//                               </button>
//                               <ul
//                                 className="dropdown-menu"
//                                 style={{
//                                   zIndex: 9999,
//                                   borderRadius: "14px",
//                                   border: "none",
//                                   padding: "8px",
//                                   boxShadow:
//                                     "0 12px 40px rgba(30, 87, 153, 0.18), 0 4px 12px rgba(0,0,0,0.06)",
//                                   minWidth: "230px",
//                                   marginTop: "8px",
//                                   background: "#ffffff",
//                                 }}
//                               >
//                                 <li>
//                                   <button
//                                     className="dropdown-item d-flex align-items-center"
//                                     onClick={() => handleEditClick(account.id)}
//                                     style={dropdownItem}
//                                     onMouseEnter={(e) => {
//                                       e.currentTarget.style.background =
//                                         "#e8f1fb";
//                                       e.currentTarget.style.transform =
//                                         "translateX(3px)";
//                                     }}
//                                     onMouseLeave={(e) => {
//                                       e.currentTarget.style.background =
//                                         "transparent";
//                                       e.currentTarget.style.transform =
//                                         "translateX(0)";
//                                     }}
//                                   >
//                                     <span
//                                       style={iconBadge("#e8f1fb", "#1e5799")}
//                                     >
//                                       <FaEdit size={13} />
//                                     </span>
//                                     Edit Account
//                                   </button>
//                                 </li>

//                                 <li>
//                                   <button
//                                     className="dropdown-item d-flex align-items-center"
//                                     onClick={() =>
//                                       handleViewImagesClick(account)
//                                     }
//                                     style={dropdownItem}
//                                     onMouseEnter={(e) => {
//                                       e.currentTarget.style.background =
//                                         "#f3e8ff";
//                                       e.currentTarget.style.transform =
//                                         "translateX(3px)";
//                                     }}
//                                     onMouseLeave={(e) => {
//                                       e.currentTarget.style.background =
//                                         "transparent";
//                                       e.currentTarget.style.transform =
//                                         "translateX(0)";
//                                     }}
//                                   >
//                                     <span
//                                       style={iconBadge("#f3e8ff", "#7c3aed")}
//                                     >
//                                       <svg
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         width="13"
//                                         height="13"
//                                         fill="currentColor"
//                                         viewBox="0 0 16 16"
//                                       >
//                                         <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
//                                         <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
//                                       </svg>
//                                     </span>
//                                     View Images
//                                   </button>
//                                 </li>

//                                 <li>
//                                   <hr
//                                     style={{
//                                       margin: "6px 8px",
//                                       border: "none",
//                                       borderTop: "1.5px dashed #e2e8f0",
//                                     }}
//                                   />
//                                 </li>

//                                 <li>
//                                   <button
//                                     className="dropdown-item d-flex align-items-center"
//                                     onClick={() => handleDeleteClick(account)}
//                                     style={{
//                                       ...dropdownItem,
//                                       color: "#dc2626",
//                                     }}
//                                     onMouseEnter={(e) => {
//                                       e.currentTarget.style.background =
//                                         "#feeaeb";
//                                       e.currentTarget.style.transform =
//                                         "translateX(3px)";
//                                     }}
//                                     onMouseLeave={(e) => {
//                                       e.currentTarget.style.background =
//                                         "transparent";
//                                       e.currentTarget.style.transform =
//                                         "translateX(0)";
//                                     }}
//                                   >
//                                     <span
//                                       style={iconBadge("#feeaeb", "#dc2626")}
//                                     >
//                                       <RiDeleteBin3Fill size={13} />
//                                     </span>
//                                     Delete Account
//                                   </button>
//                                 </li>
//                               </ul>
//                             </div>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>

//                 {/* Pagination */}
//                 {totalPages > 1 && (
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "center",
//                       alignItems: "center",
//                       marginTop: "24px",
//                       gap: "6px",
//                       flexWrap: "wrap",
//                     }}
//                   >
//                     <button
//                       onClick={() => handlePageChange(currentPage - 1)}
//                       disabled={currentPage === 1}
//                       style={{
//                         padding: "8px 14px",
//                         borderRadius: "10px",
//                         border: "1.5px solid #e2e8f0",
//                         background: "#ffffff",
//                         color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
//                         fontWeight: "700",
//                         fontSize: "13px",
//                         cursor: currentPage === 1 ? "not-allowed" : "pointer",
//                         display: "inline-flex",
//                         alignItems: "center",
//                         gap: "6px",
//                       }}
//                     >
//                       ‹ Prev
//                     </button>

//                     {getPageNumbers().map((p, i) => {
//                       if (p === "left-ellipsis" || p === "right-ellipsis") {
//                         return (
//                           <span
//                             key={`ellipsis-${i}`}
//                             style={{
//                               padding: "0 6px",
//                               color: "#94a3b8",
//                               fontWeight: "700",
//                             }}
//                           >
//                             ...
//                           </span>
//                         );
//                       }
//                       const isActive = p === currentPage;
//                       return (
//                         <button
//                           key={p}
//                           onClick={() => handlePageChange(p)}
//                           style={{
//                             minWidth: "38px",
//                             height: "38px",
//                             borderRadius: "10px",
//                             border: isActive
//                               ? "none"
//                               : "1.5px solid #e2e8f0",
//                             background: isActive
//                               ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
//                               : "#ffffff",
//                             color: isActive ? "#ffffff" : "#334155",
//                             fontWeight: "700",
//                             fontSize: "13px",
//                             cursor: "pointer",
//                             boxShadow: isActive
//                               ? "0 6px 16px rgba(30, 87, 153, 0.3)"
//                               : "none",
//                             transition: "all 0.18s ease",
//                           }}
//                         >
//                           {p}
//                         </button>
//                       );
//                     })}

//                     <button
//                       onClick={() => handlePageChange(currentPage + 1)}
//                       disabled={currentPage === totalPages}
//                       style={{
//                         padding: "8px 14px",
//                         borderRadius: "10px",
//                         border: "1.5px solid #e2e8f0",
//                         background: "#ffffff",
//                         color:
//                           currentPage === totalPages ? "#cbd5e1" : "#1e5799",
//                         fontWeight: "700",
//                         fontSize: "13px",
//                         cursor:
//                           currentPage === totalPages
//                             ? "not-allowed"
//                             : "pointer",
//                         display: "inline-flex",
//                         alignItems: "center",
//                         gap: "6px",
//                       }}
//                     >
//                       Next ›
//                     </button>
//                   </div>
//                 )}

//                 {totalItems > 0 && (
//                   <p
//                     style={{
//                       textAlign: "center",
//                       fontSize: "12px",
//                       color: "#94a3b8",
//                       marginTop: "12px",
//                       marginBottom: 0,
//                       fontWeight: "500",
//                     }}
//                   >
//                     Page {currentPage} of {totalPages} • {totalItems} total
//                     records
//                   </p>
//                 )}
//               </>
//             )}
//           </div>
//         </div>

//         {/* Footer */}
//         <p
//           style={{
//             textAlign: "center",
//             color: "#94a3b8",
//             fontSize: "12.5px",
//             marginTop: "24px",
//             fontWeight: "500",
//           }}
//         >
//           © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All Rights
//           Reserved.
//         </p>
//       </div>

//       {/* ═══════════════════════════════════════════ */}
//       {/* 🎯 EDIT MODAL */}
//       {/* ═══════════════════════════════════════════ */}
//       <Modal
//         show={editModalData.show}
//         onHide={handleEditModalClose}
//         size="lg"
//         centered
//         backdrop="static"
//         style={{ zIndex: 99999 }}
//       >
//         <Modal.Header
//           closeButton
//           style={{
//             background: "#1e5799",
//             color: "#ffffff",
//             border: "none",
//             padding: "18px 24px",
//           }}
//         >
//           <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
//             ✏️ Edit Bank Account
//           </Modal.Title>
//         </Modal.Header>
//         <Form onSubmit={handleUpdateBankAccount}>
//           <Modal.Body
//             style={{ padding: "24px", maxHeight: "70vh", overflowY: "auto" }}
//           >
//             <Form.Group className="mb-3">
//               <Form.Label style={labelStyle}>Payee</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="payee"
//                 value={editModalData.payee || ""}
//                 onChange={handleEditFormChange}
//                 required
//                 style={inputStyle}
//               />
//             </Form.Group>

//             {editModalData.type === "online" && (
//               <>
//                 <Form.Group className="mb-3">
//                   <Form.Label style={labelStyle}>Bank Name</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="bank_account_name"
//                     value={editModalData.bank_account_name || ""}
//                     onChange={handleEditFormChange}
//                     required
//                     style={inputStyle}
//                   />
//                 </Form.Group>
//                 <Form.Group className="mb-3">
//                   <Form.Label style={labelStyle}>Account Number</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="account_number"
//                     value={editModalData.account_number || ""}
//                     onChange={handleEditFormChange}
//                     required
//                     style={inputStyle}
//                   />
//                 </Form.Group>
//                 <Form.Group className="mb-3">
//                   <Form.Label style={labelStyle}>IFSC Code</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="ifsc_code"
//                     value={editModalData.ifsc_code || ""}
//                     onChange={handleEditFormChange}
//                     required
//                     style={inputStyle}
//                   />
//                 </Form.Group>
//               </>
//             )}

//             <Form.Group className="mb-3">
//               <Form.Label style={labelStyle}>Account Type</Form.Label>
//               <Form.Select
//                 name="type"
//                 value={editModalData.type || ""}
//                 onChange={handleEditFormChange}
//                 required
//                 style={inputStyle}
//               >
//                 <option value="">Select Type</option>
//                 <option value="online">✅ Online</option>
//                 <option value="cash">💵 Cash</option>
//               </Form.Select>
//             </Form.Group>

//             <Form.Group className="mb-3">
//               <Form.Label style={labelStyle}>
//                 Bank Passbook/Cheque Images
//               </Form.Label>
//               <Form.Control
//                 type="file"
//                 multiple
//                 accept="image/*"
//                 onChange={handleImageChange}
//                 style={inputStyle}
//               />
//               <Form.Text
//                 style={{
//                   color: "#64748b",
//                   fontSize: "11.5px",
//                   fontWeight: "500",
//                 }}
//               >
//                 You can select multiple images. Maximum file size: 5MB each.
//               </Form.Text>
//             </Form.Group>

//             {(editModalData.existing_images.length > 0 ||
//               imagePreviews.length > 0) && (
//               <div style={{ marginTop: "16px" }}>
//                 <h6
//                   style={{
//                     fontWeight: "800",
//                     color: "#1e5799",
//                     fontSize: "13px",
//                     marginBottom: "12px",
//                   }}
//                 >
//                   📷 Images
//                 </h6>
//                 <div
//                   style={{
//                     display: "flex",
//                     flexWrap: "wrap",
//                     gap: "10px",
//                   }}
//                 >
//                   {editModalData.existing_images.map((image, index) => (
//                     <div
//                       key={`existing-${index}`}
//                       style={{
//                         position: "relative",
//                         width: "100px",
//                         height: "100px",
//                       }}
//                     >
//                       <img
//                         src={`${IMG_URL}/loanlead/${image}`}
//                         alt={`Existing ${index + 1}`}
//                         style={{
//                           width: "100%",
//                           height: "100%",
//                           objectFit: "cover",
//                           borderRadius: "10px",
//                           border: "1.5px solid #e2e8f0",
//                         }}
//                       />
//                       <button
//                         type="button"
//                         onClick={() => removeImage(index, true)}
//                         style={{
//                           position: "absolute",
//                           top: "-6px",
//                           right: "-6px",
//                           width: "22px",
//                           height: "22px",
//                           borderRadius: "50%",
//                           border: "none",
//                           background: "#dc2626",
//                           color: "#ffffff",
//                           fontSize: "12px",
//                           fontWeight: "700",
//                           cursor: "pointer",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
//                         }}
//                       >
//                         ×
//                       </button>
//                     </div>
//                   ))}
//                   {imagePreviews.map((preview, index) => (
//                     <div
//                       key={`new-${index}`}
//                       style={{
//                         position: "relative",
//                         width: "100px",
//                         height: "100px",
//                       }}
//                     >
//                       <img
//                         src={preview}
//                         alt={`New ${index + 1}`}
//                         style={{
//                           width: "100%",
//                           height: "100%",
//                           objectFit: "cover",
//                           borderRadius: "10px",
//                           border: "1.5px solid #22c55e",
//                         }}
//                       />
//                       <button
//                         type="button"
//                         onClick={() =>
//                           removeImage(
//                             editModalData.existing_images.length + index,
//                             false
//                           )
//                         }
//                         style={{
//                           position: "absolute",
//                           top: "-6px",
//                           right: "-6px",
//                           width: "22px",
//                           height: "22px",
//                           borderRadius: "50%",
//                           border: "none",
//                           background: "#dc2626",
//                           color: "#ffffff",
//                           fontSize: "12px",
//                           fontWeight: "700",
//                           cursor: "pointer",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
//                         }}
//                       >
//                         ×
//                       </button>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             )}
//           </Modal.Body>
//           <Modal.Footer
//             style={{
//               borderTop: "1.5px solid #e2e8f0",
//               padding: "16px 24px",
//               gap: "10px",
//             }}
//           >
//             <button
//               type="button"
//               onClick={handleEditModalClose}
//               style={{
//                 padding: "10px 22px",
//                 borderRadius: "10px",
//                 border: "1.5px solid #e2e8f0",
//                 background: "#ffffff",
//                 color: "#64748b",
//                 fontSize: "13px",
//                 fontWeight: "700",
//                 cursor: "pointer",
//               }}
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               disabled={actionLoading}
//               style={{
//                 padding: "10px 22px",
//                 borderRadius: "10px",
//                 border: "none",
//                 background: actionLoading
//                   ? "#cbd5e1"
//                   : "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 color: "#ffffff",
//                 fontSize: "13px",
//                 fontWeight: "700",
//                 cursor: actionLoading ? "not-allowed" : "pointer",
//                 boxShadow: actionLoading
//                   ? "none"
//                   : "0 4px 12px rgba(30, 87, 153, 0.3)",
//               }}
//             >
//               {actionLoading ? "Updating..." : "Save Changes"}
//             </button>
//           </Modal.Footer>
//         </Form>
//       </Modal>

//       {/* ═══════════════════════════════════════════ */}
//       {/* 🎯 DELETE MODAL */}
//       {/* ═══════════════════════════════════════════ */}
//       <Modal
//         show={deleteModalData.show}
//         onHide={handleDeleteModalClose}
//         centered
//         backdrop="static"
//         style={{ zIndex: 99999 }}
//       >
//         <Modal.Header
//           closeButton
//           style={{
//             background: "#dc2626",
//             color: "#ffffff",
//             border: "none",
//             padding: "18px 24px",
//           }}
//         >
//           <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
//             ⚠️ Confirm Deletion
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body style={{ padding: "24px", fontSize: "14px", color: "#334155" }}>
//           Are you sure you want to delete the bank account for{" "}
//           <strong>"{deleteModalData.name}"</strong>? This action cannot be
//           undone.
//         </Modal.Body>
//         <Modal.Footer
//           style={{
//             borderTop: "1.5px solid #e2e8f0",
//             padding: "16px 24px",
//             gap: "10px",
//           }}
//         >
//           <button
//             type="button"
//             onClick={handleDeleteModalClose}
//             style={{
//               padding: "10px 22px",
//               borderRadius: "10px",
//               border: "1.5px solid #e2e8f0",
//               background: "#ffffff",
//               color: "#64748b",
//               fontSize: "13px",
//               fontWeight: "700",
//               cursor: "pointer",
//             }}
//           >
//             Cancel
//           </button>
//           <button
//             type="button"
//             onClick={handleDeleteBankAccount}
//             disabled={actionLoading}
//             style={{
//               padding: "10px 22px",
//               borderRadius: "10px",
//               border: "none",
//               background: actionLoading
//                 ? "#cbd5e1"
//                 : "linear-gradient(135deg, #dc2626, #b91c1c)",
//               color: "#ffffff",
//               fontSize: "13px",
//               fontWeight: "700",
//               cursor: actionLoading ? "not-allowed" : "pointer",
//               boxShadow: actionLoading
//                 ? "none"
//                 : "0 4px 12px rgba(220, 38, 38, 0.3)",
//             }}
//           >
//             {actionLoading ? "Deleting..." : "Delete"}
//           </button>
//         </Modal.Footer>
//       </Modal>

//       {/* ═══════════════════════════════════════════ */}
//       {/* 🎯 IMAGES VIEW MODAL */}
//       {/* ═══════════════════════════════════════════ */}
//       <Modal
//         show={imagesModalData.show}
//         onHide={handleImagesModalClose}
//         size="lg"
//         centered
//         backdrop="static"
//         style={{ zIndex: 99999 }}
//       >
//         <Modal.Header
//           closeButton
//           style={{
//             background: "#1e5799",
//             color: "#ffffff",
//             border: "none",
//             padding: "18px 24px",
//           }}
//         >
//           <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
//             📷 {imagesModalData.title}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body style={{ padding: "24px" }}>
//           {imagesModalData.images.length > 0 ? (
//             <Carousel>
//               {imagesModalData.images.map((image, index) => (
//                 <Carousel.Item key={index}>
//                   <div className="d-flex justify-content-center">
//                     <img
//                       src={`${IMG_URL}/loanlead/${image}`}
//                       alt={`Bank document ${index + 1}`}
//                       style={{
//                         maxHeight: "400px",
//                         maxWidth: "100%",
//                         borderRadius: "12px",
//                         border: "1.5px solid #e2e8f0",
//                       }}
//                     />
//                   </div>
//                 </Carousel.Item>
//               ))}
//             </Carousel>
//           ) : (
//             <p style={{ textAlign: "center", color: "#94a3b8" }}>
//               📭 No images available
//             </p>
//           )}
//         </Modal.Body>
//         <Modal.Footer
//           style={{ borderTop: "1.5px solid #e2e8f0", padding: "16px 24px" }}
//         >
//           <button
//             type="button"
//             onClick={handleImagesModalClose}
//             style={{
//               padding: "10px 22px",
//               borderRadius: "10px",
//               border: "none",
//               background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//               color: "#ffffff",
//               fontSize: "13px",
//               fontWeight: "700",
//               cursor: "pointer",
//               boxShadow: "0 4px 12px rgba(30, 87, 153, 0.3)",
//             }}
//           >
//             Close
//           </button>
//         </Modal.Footer>
//       </Modal>

//       <style>{`
//         @keyframes spin {
//           from { transform: rotate(0deg); }
//           to { transform: rotate(360deg); }
//         }
//       `}</style>
//     </div>
//   );
// }

// // ═══════════════════════════════════════════
// // 🎨 SHARED STYLES
// // ═══════════════════════════════════════════
// const labelStyle = {
//   display: "block",
//   fontSize: "12.5px",
//   fontWeight: "700",
//   color: "#1e3a5f",
//   marginBottom: "6px",
// };

// const inputStyle = {
//   width: "100%",
//   padding: "10px 14px",
//   borderRadius: "10px",
//   border: "1.5px solid #e2e8f0",
//   fontSize: "13.5px",
//   fontWeight: "500",
//   color: "#1e3a5f",
//   outline: "none",
//   boxSizing: "border-box",
// };

// const cellBlue = { padding: "12px", fontWeight: "700", color: "#1e5799" };
// const cellDark = { padding: "12px", fontWeight: "600", color: "#1e3a5f" };
// const cellGray = { padding: "12px", color: "#64748b" };

// const dropdownItem = {
//   padding: "9px 12px",
//   borderRadius: "10px",
//   fontSize: "13px",
//   fontWeight: "600",
//   gap: "10px",
//   transition: "all 0.18s ease",
//   marginBottom: "2px",
//   border: "none",
//   background: "transparent",
//   width: "100%",
//   textAlign: "left",
//   color: "#1e5799",
// };

// const iconBadge = (bg, color) => ({
//   width: "28px",
//   height: "28px",
//   borderRadius: "8px",
//   background: bg,
//   color: color,
//   display: "inline-flex",
//   alignItems: "center",
//   justifyContent: "center",
//   flexShrink: 0,
// });

// export default BankAccountList;

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaPlus, FaEdit } from "react-icons/fa";
import { Modal, Form, Row, Col, Carousel } from "react-bootstrap";
import { RiDeleteBin3Fill } from "react-icons/ri";
import { BsThreeDots } from "react-icons/bs";
import Swal from "sweetalert2";

const API_URL = process.env.REACT_APP_API_URL;
const IMG_URL = process.env.REACT_APP_Image_URL;
const LIMIT = 10;

// ─── Shared modal / input styles ───
const labelStyle = {
  display: "block",
  fontSize: "12.5px",
  fontWeight: "700",
  color: "#1e3a5f",
  marginBottom: "6px",
};

const inputStyle = {
  width: "100%",
  padding: "10px 14px",
  borderRadius: "10px",
  border: "1.5px solid #e2e8f0",
  fontSize: "13.5px",
  fontWeight: "500",
  color: "#1e3a5f",
  outline: "none",
  boxSizing: "border-box",
};

const cellBlue = { padding: "12px", fontWeight: "700", color: "#1e5799" };
const cellDark = { padding: "12px", fontWeight: "600", color: "#1e3a5f" };
const cellGray = { padding: "12px", color: "#64748b" };

const dropdownItem = {
  padding: "9px 12px",
  borderRadius: "10px",
  fontSize: "13px",
  fontWeight: "600",
  gap: "10px",
  transition: "all 0.18s ease",
  marginBottom: "2px",
  border: "none",
  background: "transparent",
  width: "100%",
  textAlign: "left",
  color: "#1e5799",
};

const iconBadge = (bg, color) => ({
  width: "28px",
  height: "28px",
  borderRadius: "8px",
  background: bg,
  color: color,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

function BankAccountList() {
  const navigate = useNavigate();
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [actionLoading, setActionLoading] = useState(false);

  const [editModalData, setEditModalData] = useState({
    show: false,
    id: null,
    payee: "",
    bank_account_name: "",
    account_number: "",
    ifsc_code: "",
    type: "",
    images: [],
    existing_images: [],
  });

  const [deleteModalData, setDeleteModalData] = useState({
    show: false,
    id: null,
    name: "",
  });

  const [imagesModalData, setImagesModalData] = useState({
    show: false,
    images: [],
    title: "",
  });

  const [newImages, setNewImages] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);

  const getAuthToken = () => localStorage.getItem("token");

  // ═══════════════════════════════════════════
  // 🔹 FETCH BANK ACCOUNTS
  // ═══════════════════════════════════════════
  const fetchBankAccounts = async (page = 1) => {
    setLoading(true);
    const token = getAuthToken();
    if (!token) {
      setError("Authentication token not found. Please log in.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `${API_URL}/expence-bank-account-list?page=${page}&limit=${LIMIT}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (!response.ok) {
        if (response.status === 401) navigate("/login");
        throw new Error("Failed to fetch bank accounts.");
      }

      const data = await response.json();
      if (data.status) {
        const accountsWithImages = (data.data || []).map((account) => ({
          ...account,
          images: account.image ? account.image.split(",") : [],
        }));
        setAccounts(accountsWithImages);

        const pages = Number(data.totalPages) || 1;
        const total = Number(data.total) || (data.data?.length || 0);

        setTotalPages(pages);
        setTotalItems(total);
        setCurrentPage(Number(data.currentPage) || Number(page));
      } else {
        setError(data.message || "No bank accounts found.");
        setAccounts([]);
      }
    } catch (err) {
      console.error("Fetch error:", err);
      setError(err.message);
      setAccounts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBankAccounts(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  // ═══════════════════════════════════════════
  // 🔹 EDIT HANDLERS
  // ═══════════════════════════════════════════
  const handleEditClick = async (id) => {
    setActionLoading(true);
    const token = getAuthToken();
    if (!token) {
      Swal.fire("Error", "Authentication token not found.", "error");
      setActionLoading(false);
      return;
    }
    try {
      const response = await fetch(`${API_URL}/expence-bank-account-edit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id }),
      });
      const result = await response.json();
      if (response.ok && result.status) {
        setEditModalData({
          show: true,
          id: result.data.id,
          payee: result.data.payee || "",
          bank_account_name: result.data.bank_account_name || "",
          account_number: result.data.account_number || "",
          ifsc_code: result.data.ifsc_code || "",
          type: result.data.type || "",
          images: result.data.images || [],
          existing_images: result.data.images || [],
        });
        setNewImages([]);
        setImagePreviews([]);
      } else {
        throw new Error(result.message || "Failed to fetch account details.");
      }
    } catch (err) {
      console.error("Edit fetch error:", err);
      Swal.fire("Error", err.message, "error");
    } finally {
      setActionLoading(false);
    }
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditModalData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter((file) => {
      if (!file.type.startsWith("image/")) {
        Swal.fire("Warning", "Only image files are allowed.", "warning");
        return false;
      }
      if (file.size > 5 * 1024 * 1024) {
        Swal.fire("Warning", "Image size should be less than 5MB.", "warning");
        return false;
      }
      return true;
    });

    setNewImages((prev) => [...prev, ...validFiles]);
    const newPreviews = validFiles.map((file) => URL.createObjectURL(file));
    setImagePreviews((prev) => [...prev, ...newPreviews]);
  };

  const removeImage = (index, isExisting = false) => {
    if (isExisting) {
      setEditModalData((prev) => ({
        ...prev,
        existing_images: prev.existing_images.filter((_, i) => i !== index),
      }));
    } else {
      const newIndex = index - editModalData.existing_images.length;
      setNewImages((prev) => prev.filter((_, i) => i !== newIndex));
      setImagePreviews((prev) => {
        URL.revokeObjectURL(prev[index]);
        return prev.filter((_, i) => i !== index);
      });
    }
  };

  const handleUpdateBankAccount = async (e) => {
    e.preventDefault();
    setActionLoading(true);
    const token = getAuthToken();

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("id", editModalData.id);
      formDataToSend.append("payee", editModalData.payee);
      formDataToSend.append("type", editModalData.type);
      formDataToSend.append(
        "existing_images",
        JSON.stringify(editModalData.existing_images)
      );

      if (editModalData.type === "online") {
        formDataToSend.append(
          "bank_account_name",
          editModalData.bank_account_name
        );
        formDataToSend.append("account_number", editModalData.account_number);
        formDataToSend.append("ifsc_code", editModalData.ifsc_code);
      }

      newImages.forEach((image) => {
        formDataToSend.append(`images`, image);
      });

      const response = await fetch(`${API_URL}/expence-bank-account-update`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formDataToSend,
      });

      const result = await response.json();
      if (result.success == "1") {
        Swal.fire("Success", "Bank account updated successfully!", "success");
        handleEditModalClose();
        fetchBankAccounts(currentPage);
      } else {
        throw new Error(result.message || "Failed to update bank account.");
      }
    } catch (err) {
      console.error("Update error:", err);
      Swal.fire("Error", err.message, "error");
    } finally {
      setActionLoading(false);
    }
  };

  const handleEditModalClose = () => {
    setEditModalData({
      show: false,
      id: null,
      payee: "",
      bank_account_name: "",
      account_number: "",
      ifsc_code: "",
      type: "",
      images: [],
      existing_images: [],
    });
    setNewImages([]);
    setImagePreviews([]);
  };

  // ═══════════════════════════════════════════
  // 🔹 DELETE HANDLERS
  // ═══════════════════════════════════════════
  const handleDeleteClick = (account) => {
    setDeleteModalData({
      show: true,
      id: account.id,
      name: account.payee,
    });
  };

  const handleDeleteModalClose = () => {
    setDeleteModalData({ show: false, id: null, name: "" });
  };

  const handleDeleteBankAccount = async () => {
    setActionLoading(true);
    const token = getAuthToken();

    try {
      const response = await fetch(`${API_URL}/expence-bank-account-delete`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: deleteModalData.id }),
      });

      const result = await response.json();
      if (response.ok && result.status) {
        Swal.fire("Success", "Bank account deleted successfully!", "success");
        handleDeleteModalClose();
        fetchBankAccounts(currentPage);
      } else {
        throw new Error(result.message || "Failed to delete bank account.");
      }
    } catch (err) {
      console.error("Delete error:", err);
      Swal.fire("Error", err.message, "error");
    } finally {
      setActionLoading(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 IMAGES VIEW
  // ═══════════════════════════════════════════
  const handleViewImagesClick = (account) => {
    setImagesModalData({
      show: true,
      images: account.images,
      title: `Images for ${account.payee}`,
    });
  };

  const handleImagesModalClose = () => {
    setImagesModalData({ show: false, images: [], title: "" });
  };

  // ═══════════════════════════════════════════
  // 🔹 PAGINATION NUMBERS
  // ═══════════════════════════════════════════
  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;

    pages.push(1);
    if (showEllipsis && currentPage > 4) pages.push("left-ellipsis");

    const start = Math.max(2, currentPage - 2);
    const end = Math.min(totalPages - 1, currentPage + 2);

    for (let i = start; i <= end; i++) pages.push(i);

    if (showEllipsis && currentPage < totalPages - 3)
      pages.push("right-ellipsis");
    if (totalPages > 1) pages.push(totalPages);

    return pages;
  };

  // ═══════════════════════════════════════════
  // 🎨 RENDER
  // ═══════════════════════════════════════════
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        padding: "24px",
        fontFamily: "'Poppins', 'DM Sans', sans-serif",
      }}
    >
      <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
        <div
          style={{
            background: "#ffffff",
            borderRadius: "20px",
            boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
            border: "1.5px solid #e2e8f0",
            overflow: "hidden",
          }}
        >
          {/* Top Gradient */}
          <div
            style={{
              height: "5px",
              background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
            }}
          />

          {/* Header */}
          <div
            style={{
              padding: "24px 30px",
              background: "linear-gradient(135deg, #ffffff, #f8fafc)",
              borderBottom: "1.5px solid #e2e8f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "14px",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  fontSize: "22px",
                  boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                  flexShrink: 0,
                }}
              >
                🏦
              </div>
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "22px",
                    fontWeight: "800",
                    color: "#1e3a5f",
                  }}
                >
                  Bank Accounts
                </h2>
                <p
                  style={{
                    margin: "2px 0 0",
                    fontSize: "12.5px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  Manage all your bank accounts ({totalItems} total)
                </p>
              </div>
            </div>

            <Link
              to="/add-bankaccount"
              style={{
                padding: "10px 18px",
                borderRadius: "10px",
                border: "none",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                color: "#ffffff",
                fontSize: "13px",
                fontWeight: "700",
                textDecoration: "none",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
              }}
            >
              <FaPlus /> Add Bank Account
            </Link>
          </div>

          {/* Body */}
          <div style={{ padding: "24px 30px" }}>
            {loading ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "60px 20px",
                  color: "#64748b",
                }}
              >
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    border: "3px solid #cbd5e1",
                    borderTop: "3px solid #2b6cb0",
                    borderRadius: "50%",
                    display: "inline-block",
                    animation: "spin 0.8s linear infinite",
                  }}
                />
                <p
                  style={{
                    marginTop: "16px",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  Loading bank accounts...
                </p>
              </div>
            ) : error ? (
              <div
                style={{
                  background: "#feeaeb",
                  border: "1.5px solid #fecaca",
                  color: "#991b1b",
                  borderRadius: "12px",
                  padding: "14px 18px",
                  fontWeight: "600",
                  fontSize: "13.5px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <span>⚠️ {error}</span>
                <button
                  onClick={() => fetchBankAccounts()}
                  style={{
                    padding: "6px 14px",
                    borderRadius: "8px",
                    border: "none",
                    background: "#dc2626",
                    color: "#ffffff",
                    fontWeight: "700",
                    fontSize: "12px",
                    cursor: "pointer",
                  }}
                >
                  Retry
                </button>
              </div>
            ) : accounts.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "50px",
                  color: "#94a3b8",
                  fontWeight: "600",
                }}
              >
                📭 No bank accounts found.
              </div>
            ) : (
              <>
                <div
                  style={{
                    overflowX: "auto",
                    overflowY: "visible",
                    borderRadius: "14px",
                    border: "1.5px solid #e2e8f0",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      minWidth: "1100px",
                      borderCollapse: "collapse",
                      fontSize: "13px",
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          background:
                            "linear-gradient(135deg, #1e5799, #2b6cb0)",
                        }}
                      >
                        {[
                          "S.N",
                          "Payee Name",
                          "Branch Name",
                          "Bank Name",
                          "Account Number",
                          "IFSC Code",
                          "Type",
                          "Date",
                          "Actions",
                        ].map((th, i) => (
                          <th
                            key={i}
                            style={{
                              padding: "14px 12px",
                              color: "#ffffff",
                              fontWeight: "700",
                              fontSize: "11.5px",
                              textAlign: "left",
                              letterSpacing: "0.5px",
                              textTransform: "uppercase",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {th}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {accounts.map((account, index) => (
                        <tr
                          key={account.id}
                          style={{ borderBottom: "1px solid #f1f5f9" }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.background = "#f8fafc")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.background = "transparent")
                          }
                        >
                          <td style={cellBlue}>
                            {(currentPage - 1) * LIMIT + index + 1}
                          </td>
                          <td style={cellDark}>
                            {account.payee
                              ? account.payee.charAt(0).toUpperCase() +
                                account.payee.slice(1).toLowerCase()
                              : "-"}
                          </td>
                          <td style={cellGray}>
                            {account.bank_branch_name || "NA"}
                          </td>
                          <td style={cellDark}>
                            {account.bank_account_name
                              ? account.bank_account_name
                                  .charAt(0)
                                  .toUpperCase() +
                                account.bank_account_name.slice(1).toLowerCase()
                              : "-"}
                          </td>
                          <td style={cellGray}>
                            {account.account_number || "-"}
                          </td>
                          <td style={cellGray}>{account.ifsc_code || "-"}</td>
                          <td style={{ padding: "12px" }}>
                            <span
                              style={{
                                display: "inline-block",
                                padding: "4px 12px",
                                borderRadius: "20px",
                                fontSize: "11.5px",
                                fontWeight: "700",
                                background:
                                  account.type === "online"
                                    ? "#e8f1fb"
                                    : "#e7f9eb",
                                color:
                                  account.type === "online"
                                    ? "#1e5799"
                                    : "#059669",
                                textTransform: "capitalize",
                              }}
                            >
                              {account.type
                                ? account.type.charAt(0).toUpperCase() +
                                  account.type.slice(1).toLowerCase()
                                : "-"}
                            </span>
                          </td>
                          <td style={{ ...cellGray, whiteSpace: "nowrap" }}>
                            {account.created_at
                              ? new Date(account.created_at)
                                  .toLocaleDateString("en-GB")
                                  .replace(/\//g, "-")
                              : "-"}
                          </td>
                          <td style={{ padding: "12px" }}>
                            <div className="dropdown">
                              <button
                                className="btn dropdown-toggle"
                                type="button"
                                data-bs-toggle="dropdown"
                                data-bs-boundary="viewport"
                                data-bs-popper-config='{"strategy":"fixed"}'
                                aria-expanded="false"
                                style={{
                                  background: "#f8fafc",
                                  border: "1.5px solid #e2e8f0",
                                  borderRadius: "8px",
                                  width: "36px",
                                  height: "36px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#1e5799",
                                  padding: 0,
                                }}
                              >
                                <BsThreeDots size={18} />
                              </button>
                              <ul
                                className="dropdown-menu"
                                style={{
                                  zIndex: 9999,
                                  borderRadius: "14px",
                                  border: "none",
                                  padding: "8px",
                                  boxShadow:
                                    "0 12px 40px rgba(30, 87, 153, 0.18), 0 4px 12px rgba(0,0,0,0.06)",
                                  minWidth: "230px",
                                  marginTop: "8px",
                                  background: "#ffffff",
                                }}
                              >
                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center"
                                    onClick={() => handleEditClick(account.id)}
                                    style={dropdownItem}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.background =
                                        "#e8f1fb";
                                      e.currentTarget.style.transform =
                                        "translateX(3px)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.background =
                                        "transparent";
                                      e.currentTarget.style.transform =
                                        "translateX(0)";
                                    }}
                                  >
                                    <span
                                      style={iconBadge("#e8f1fb", "#1e5799")}
                                    >
                                      <FaEdit size={13} />
                                    </span>
                                    Edit Account
                                  </button>
                                </li>

                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center"
                                    onClick={() =>
                                      handleViewImagesClick(account)
                                    }
                                    style={dropdownItem}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.background =
                                        "#f3e8ff";
                                      e.currentTarget.style.transform =
                                        "translateX(3px)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.background =
                                        "transparent";
                                      e.currentTarget.style.transform =
                                        "translateX(0)";
                                    }}
                                  >
                                    <span
                                      style={iconBadge("#f3e8ff", "#7c3aed")}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="13"
                                        height="13"
                                        fill="currentColor"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                        <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                                      </svg>
                                    </span>
                                    View Images
                                  </button>
                                </li>

                                <li>
                                  <hr
                                    style={{
                                      margin: "6px 8px",
                                      border: "none",
                                      borderTop: "1.5px dashed #e2e8f0",
                                    }}
                                  />
                                </li>

                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center"
                                    onClick={() => handleDeleteClick(account)}
                                    style={{
                                      ...dropdownItem,
                                      color: "#dc2626",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.background =
                                        "#feeaeb";
                                      e.currentTarget.style.transform =
                                        "translateX(3px)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.background =
                                        "transparent";
                                      e.currentTarget.style.transform =
                                        "translateX(0)";
                                    }}
                                  >
                                    <span
                                      style={iconBadge("#feeaeb", "#dc2626")}
                                    >
                                      <RiDeleteBin3Fill size={13} />
                                    </span>
                                    Delete Account
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "24px",
                      gap: "6px",
                      flexWrap: "wrap",
                    }}
                  >
                    <button
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                      style={{
                        padding: "8px 14px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
                        fontWeight: "700",
                        fontSize: "13px",
                        cursor: currentPage === 1 ? "not-allowed" : "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      ‹ Prev
                    </button>

                    {getPageNumbers().map((p, i) => {
                      if (p === "left-ellipsis" || p === "right-ellipsis") {
                        return (
                          <span
                            key={`ellipsis-${i}`}
                            style={{
                              padding: "0 6px",
                              color: "#94a3b8",
                              fontWeight: "700",
                            }}
                          >
                            ...
                          </span>
                        );
                      }
                      const isActive = p === currentPage;
                      return (
                        <button
                          key={p}
                          onClick={() => handlePageChange(p)}
                          style={{
                            minWidth: "38px",
                            height: "38px",
                            borderRadius: "10px",
                            border: isActive
                              ? "none"
                              : "1.5px solid #e2e8f0",
                            background: isActive
                              ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                              : "#ffffff",
                            color: isActive ? "#ffffff" : "#334155",
                            fontWeight: "700",
                            fontSize: "13px",
                            cursor: "pointer",
                            boxShadow: isActive
                              ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                              : "none",
                            transition: "all 0.18s ease",
                          }}
                        >
                          {p}
                        </button>
                      );
                    })}

                    <button
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      style={{
                        padding: "8px 14px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color:
                          currentPage === totalPages ? "#cbd5e1" : "#1e5799",
                        fontWeight: "700",
                        fontSize: "13px",
                        cursor:
                          currentPage === totalPages
                            ? "not-allowed"
                            : "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      Next ›
                    </button>
                  </div>
                )}

                {totalItems > 0 && (
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "12px",
                      color: "#94a3b8",
                      marginTop: "12px",
                      marginBottom: 0,
                      fontWeight: "500",
                    }}
                  >
                    Page {currentPage} of {totalPages} • {totalItems} total
                    records
                  </p>
                )}
              </>
            )}
          </div>
        </div>

        {/* Footer */}
        <p
          style={{
            textAlign: "center",
            color: "#94a3b8",
            fontSize: "12.5px",
            marginTop: "24px",
            fontWeight: "500",
          }}
        >
          © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All Rights
          Reserved.
        </p>
      </div>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 EDIT MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={editModalData.show}
        onHide={handleEditModalClose}
        size="lg"
        centered
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            ✏️ Edit Bank Account
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleUpdateBankAccount}>
          <Modal.Body
            style={{ padding: "24px", maxHeight: "70vh", overflowY: "auto" }}
          >
            <Form.Group className="mb-3">
              <Form.Label style={labelStyle}>Payee</Form.Label>
              <Form.Control
                type="text"
                name="payee"
                value={editModalData.payee || ""}
                onChange={handleEditFormChange}
                required
                style={inputStyle}
              />
            </Form.Group>

            {editModalData.type === "online" && (
              <>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Bank Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="bank_account_name"
                    value={editModalData.bank_account_name || ""}
                    onChange={handleEditFormChange}
                    required
                    style={inputStyle}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Account Number</Form.Label>
                  <Form.Control
                    type="text"
                    name="account_number"
                    value={editModalData.account_number || ""}
                    onChange={handleEditFormChange}
                    required
                    style={inputStyle}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>IFSC Code</Form.Label>
                  <Form.Control
                    type="text"
                    name="ifsc_code"
                    value={editModalData.ifsc_code || ""}
                    onChange={handleEditFormChange}
                    required
                    style={inputStyle}
                  />
                </Form.Group>
              </>
            )}

            <Form.Group className="mb-3">
              <Form.Label style={labelStyle}>Account Type</Form.Label>
              <Form.Select
                name="type"
                value={editModalData.type || ""}
                onChange={handleEditFormChange}
                required
                style={inputStyle}
              >
                <option value="">Select Type</option>
                <option value="online">✅ Online</option>
                <option value="cash">💵 Cash</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label style={labelStyle}>
                Bank Passbook/Cheque Images
              </Form.Label>
              <Form.Control
                type="file"
                multiple
                accept="image/*"
                onChange={handleImageChange}
                style={inputStyle}
              />
              <Form.Text
                style={{
                  color: "#64748b",
                  fontSize: "11.5px",
                  fontWeight: "500",
                }}
              >
                You can select multiple images. Maximum file size: 5MB each.
              </Form.Text>
            </Form.Group>

            {(editModalData.existing_images.length > 0 ||
              imagePreviews.length > 0) && (
              <div style={{ marginTop: "16px" }}>
                <h6
                  style={{
                    fontWeight: "800",
                    color: "#1e5799",
                    fontSize: "13px",
                    marginBottom: "12px",
                  }}
                >
                  📷 Images
                </h6>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  {editModalData.existing_images.map((image, index) => (
                    <div
                      key={`existing-${index}`}
                      style={{
                        position: "relative",
                        width: "100px",
                        height: "100px",
                      }}
                    >
                      <img
                        src={`${IMG_URL}/loanlead/${image}`}
                        alt={`Existing ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "10px",
                          border: "1.5px solid #e2e8f0",
                        }}
                      />
                      <button
                        type="button"
                        onClick={() => removeImage(index, true)}
                        style={{
                          position: "absolute",
                          top: "-6px",
                          right: "-6px",
                          width: "22px",
                          height: "22px",
                          borderRadius: "50%",
                          border: "none",
                          background: "#dc2626",
                          color: "#ffffff",
                          fontSize: "12px",
                          fontWeight: "700",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                  {imagePreviews.map((preview, index) => (
                    <div
                      key={`new-${index}`}
                      style={{
                        position: "relative",
                        width: "100px",
                        height: "100px",
                      }}
                    >
                      <img
                        src={preview}
                        alt={`New ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "10px",
                          border: "1.5px solid #22c55e",
                        }}
                      />
                      <button
                        type="button"
                        onClick={() =>
                          removeImage(
                            editModalData.existing_images.length + index,
                            false
                          )
                        }
                        style={{
                          position: "absolute",
                          top: "-6px",
                          right: "-6px",
                          width: "22px",
                          height: "22px",
                          borderRadius: "50%",
                          border: "none",
                          background: "#dc2626",
                          color: "#ffffff",
                          fontSize: "12px",
                          fontWeight: "700",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer
            style={{
              borderTop: "1.5px solid #e2e8f0",
              padding: "16px 24px",
              gap: "10px",
            }}
          >
            <button
              type="button"
              onClick={handleEditModalClose}
              style={{
                padding: "10px 22px",
                borderRadius: "10px",
                border: "1.5px solid #e2e8f0",
                background: "#ffffff",
                color: "#64748b",
                fontSize: "13px",
                fontWeight: "700",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={actionLoading}
              style={{
                padding: "10px 22px",
                borderRadius: "10px",
                border: "none",
                background: actionLoading
                  ? "#cbd5e1"
                  : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                color: "#ffffff",
                fontSize: "13px",
                fontWeight: "700",
                cursor: actionLoading ? "not-allowed" : "pointer",
                boxShadow: actionLoading
                  ? "none"
                  : "0 4px 12px rgba(30, 87, 153, 0.3)",
              }}
            >
              {actionLoading ? "Updating..." : "Save Changes"}
            </button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 DELETE MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={deleteModalData.show}
        onHide={handleDeleteModalClose}
        centered
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#dc2626",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            ⚠️ Confirm Deletion
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ padding: "24px", fontSize: "14px", color: "#334155" }}
        >
          Are you sure you want to delete the bank account for{" "}
          <strong>"{deleteModalData.name}"</strong>? This action cannot be
          undone.
        </Modal.Body>
        <Modal.Footer
          style={{
            borderTop: "1.5px solid #e2e8f0",
            padding: "16px 24px",
            gap: "10px",
          }}
        >
          <button
            type="button"
            onClick={handleDeleteModalClose}
            style={{
              padding: "10px 22px",
              borderRadius: "10px",
              border: "1.5px solid #e2e8f0",
              background: "#ffffff",
              color: "#64748b",
              fontSize: "13px",
              fontWeight: "700",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleDeleteBankAccount}
            disabled={actionLoading}
            style={{
              padding: "10px 22px",
              borderRadius: "10px",
              border: "none",
              background: actionLoading
                ? "#cbd5e1"
                : "linear-gradient(135deg, #dc2626, #b91c1c)",
              color: "#ffffff",
              fontSize: "13px",
              fontWeight: "700",
              cursor: actionLoading ? "not-allowed" : "pointer",
              boxShadow: actionLoading
                ? "none"
                : "0 4px 12px rgba(220, 38, 38, 0.3)",
            }}
          >
            {actionLoading ? "Deleting..." : "Delete"}
          </button>
        </Modal.Footer>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 IMAGES VIEW MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={imagesModalData.show}
        onHide={handleImagesModalClose}
        size="lg"
        centered
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            📷 {imagesModalData.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "24px" }}>
          {imagesModalData.images.length > 0 ? (
            <Carousel>
              {imagesModalData.images.map((image, index) => (
                <Carousel.Item key={index}>
                  <div className="d-flex justify-content-center">
                    <img
                      src={`${IMG_URL}/loanlead/${image}`}
                      alt={`Bank document ${index + 1}`}
                      style={{
                        maxHeight: "400px",
                        maxWidth: "100%",
                        borderRadius: "12px",
                        border: "1.5px solid #e2e8f0",
                      }}
                    />
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          ) : (
            <p style={{ textAlign: "center", color: "#94a3b8" }}>
              📭 No images available
            </p>
          )}
        </Modal.Body>
        <Modal.Footer
          style={{ borderTop: "1.5px solid #e2e8f0", padding: "16px 24px" }}
        >
          <button
            type="button"
            onClick={handleImagesModalClose}
            style={{
              padding: "10px 22px",
              borderRadius: "10px",
              border: "none",
              background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
              color: "#ffffff",
              fontSize: "13px",
              fontWeight: "700",
              cursor: "pointer",
              boxShadow: "0 4px 12px rgba(30, 87, 153, 0.3)",
            }}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default BankAccountList;